<template>
  <div id="question" :class="[isTransition ? 'is-transition' : '']">
    <div class="question_in">
      <div
        class="question_cover"
        v-if="
          this.welcomePageIsViewed == 0 ||
            (this.sectionIsViwed == 0 && this.welcomePageIsViewed == 1)
        "
      >
        <!-- ナビゲーションロジック -->
        <div v-cloak>
          <!-- ウェルカム -->
          <div v-if="getLanguage == '日本語'">
            <div v-if="this.welcomePageIsViewed == 0" class="question_welcome">
              <p>実施言語</p>
              <v-select
                :items="getLanguages"
                :value="getLanguage"
                @input="updateLanguage"
              ></v-select>
              <div>
                <h1 class="question_welcomeTtl">睡眠偏差値を測定しましょう!</h1>
                <p class="question_welcomeTxt">
                  睡眠や生活習慣に関するいくつかの質問が表示されますので、深く考えず、感じたまま回答して下さい。
                  <br />回答には20分ほどかかります。
                </p>
              </div>
              <div class="question_policyBox">
                <TermsText />
              </div>
              <P>2022年11月1日 利用規約更新</P>
              <label
                for="privacyAgree"
                class="checkbox_label question_policyCheckbox"
              >
                <input
                  type="checkbox"
                  v-model="isAgreed"
                  id="privacyAgree"
                  class="checkbox_input"
                />
                <span class="checkbox_labelTxt">上記の規約に同意する</span>
              </label>
              <div>
                <button
                  class="btn_next btn_next-lg"
                  :class="{ 'is-negative': !isAgreed }"
                  v-on:click="viewedWelcome"
                  v-if="this.welcomePageIsViewed == 0"
                >
                  START
                </button>
              </div>
            </div>
          </div>

          <div v-if="getLanguage == '中文'">
            <div v-if="this.welcomePageIsViewed == 0" class="question_welcome">
              <p>语言</p>
              <v-select
                :items="getLanguages"
                :value="getLanguage"
                @input="updateLanguage"
              ></v-select>

              <div>
                <h1 class="question_welcomeTtl">
                  让我们来测量一下您的睡眠偏差値吧!
                </h1>
                <p class="question_welcomeTxt">
                  您会被问到一些关于您的睡眠和生活习惯的问题，请按照您的直觉回答，不需多加思考。作答时间大约20分钟。
                </p>
              </div>
              <div class="question_policyBox">
                <TermsTextCh />
              </div>
              <label
                for="privacyAgree"
                class="checkbox_label question_policyCheckbox"
              >
                <input
                  type="checkbox"
                  v-model="isAgreed"
                  id="privacyAgree"
                  class="checkbox_input"
                />
                <span class="checkbox_labelTxt">我同意上述条款</span>
              </label>
              <div>
                <button
                  class="btn_next btn_next-lg"
                  :class="{ 'is-negative': !isAgreed }"
                  v-on:click="viewedWelcome"
                  v-if="this.welcomePageIsViewed == 0"
                >
                  START
                </button>
              </div>
            </div>
          </div>

          <div v-if="getLanguage == 'English'">
            <div v-if="this.welcomePageIsViewed == 0" class="question_welcome">
              <p>Language</p>
              <v-select
                :items="getLanguages"
                :value="getLanguage"
                @input="updateLanguage"
              ></v-select>

              <div>
                <h1 class="question_welcomeTtl">
                  Let's measure your sleep deviation!
                </h1>
                <p class="question_welcomeTxt">
                  You will be asked several questions about your sleep and
                  lifestyle habits. Please answer as you feel, without thinking
                  deeply.
                  <br />It takes about 20minutes
                </p>
              </div>
              <div class="question_policyBox">
                <TermsTextEn />
              </div>
              <label
                for="privacyAgree"
                class="checkbox_label question_policyCheckbox"
              >
                <input
                  type="checkbox"
                  v-model="isAgreed"
                  id="privacyAgree"
                  class="checkbox_input"
                />
                <span class="checkbox_labelTxt"
                  >I agree to the above terms</span
                >
              </label>
              <div>
                <button
                  class="btn_next btn_next-lg"
                  :class="{ 'is-negative': !isAgreed }"
                  v-on:click="viewedWelcome"
                  v-if="this.welcomePageIsViewed == 0"
                >
                  START
                </button>
              </div>
            </div>
          </div>

          <!-- セクション -->
          <v-card
            v-if="
              this.sectionIsViwed == 0 &&
                this.welcomePageIsViewed == 1 &&
                isProfileEntered == 1 &&
                this.completed == 0
            "
            class="question_welcome"
          >
            <h1 class="question_sectionTtl">
              {{ currentSection.body }}
            </h1>
            <div>
              <button class="btn_next btn_next-lg" v-on:click="viewedSection">
                {{ questionTexts.answer_button }}
              </button>
            </div>
          </v-card>

          <!-- 回答結果確認画面 -->
          <v-card
            v-if="this.completed == 1 && this.confirmLookback == 0"
            class="question_welcome"
          >
            <h1 class="question_sectionTtl">
              {{ this.questionTexts.kakunin_title }}
            </h1>
            <div class="confirmText">
              {{ this.questionTexts.kakunin_sub }}<br />
              {{ this.questionTexts.kakunin_sub_2 }}
            </div>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left blue darken-1" style="color: white">
                      {{ questionTexts.question }}
                    </th>
                    <th class="text-left blue darken-1" style="color: white">
                      {{ questionTexts.answer_result }}
                    </th>
                    <th
                      class="text-left blue darken-1"
                      style="color: white"
                    ></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in answerConfirm[0]" :key="item.name">
                    <td align="left" class="tablefont">
                      <div v-if="getLanguage == '日本語'">
                        {{ item.question_jp }}
                      </div>
                      <div v-if="getLanguage == 'English'">
                        {{ item.question_en }}
                      </div>
                      <div v-if="getLanguage == '中文'">
                        {{ item.question_ch }}
                      </div>
                    </td>
                    <td align="left">
                      <div v-if="getLanguage == '日本語'">
                        {{ item.answers }}
                      </div>
                      <div v-if="getLanguage == 'English'">
                        {{ item.answers_en }}
                      </div>
                      <div v-if="getLanguage == '中文'">
                        {{ item.answers_ch }}
                      </div>
                    </td>
                    <td>
                      <v-btn
                        small
                        color="grey"
                        style="color: white"
                        v-on:click="
                          backToQuestion(
                            item.question_section_id - 1,
                            item.question_order - 1
                          )
                        "
                        v-if="item.answers != '回答未完了'"
                        >{{ questionTexts.modify_answer }}</v-btn
                      >
                      <v-btn
                        small
                        color="warning"
                        v-on:click="
                          backToQuestion(
                            item.question_section_id - 1,
                            item.question_order - 1
                          )
                        "
                        v-if="item.answers == '回答未完了'"
                        >{{ questionTexts.answer_button }}</v-btn
                      >
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <button
              class="btn_next btn_next-lg"
              v-on:click="toResultPath()"
              v-if="this.calcCompletedQuestions == 21"
            >
              {{ this.questionTexts.go_to_result }}
            </button>
            <br />
            <br />
            <p style="color: gray">
              {{ questionTexts.kakunin_button_caption }}
            </p>
            <div></div>
          </v-card>

          <!-- 属性情報入力 -->
          <div
            v-if="
              this.welcomePageIsViewed == 1 &&
                sectionIsViwed == 0 &&
                isProfileEntered == false
            "
          >
            <Profile :title="profileTitle" @inputProfile="isShowProfile" />
          </div>
          <!-- ナビゲーションロジック ここまで-->
        </div>
      </div>
      <transition name="fade" class="transitionBox" mode="out-in">
        <keep-alive>
          <!-- ナビゲーションロジック -->
          <!-- 共通 -->

          <!-- ナビゲーションロジック ここまで-->

          <!-- メイン表示エリア -->

          <!-- 設問進捗 = 0以上で設問表示 -->
          <span v-if="sectionIsViwed == 1 && welcomePageIsViewed == 1">
            <!-- 進捗表示 -->
            <div
              class="question_progress"
              v-if="this.confirmLookback == 0 && this.progressActive == 1"
            >
              <div class="question_progressBar">
                <div
                  class="question_progressBarIn"
                  :class="[
                    currentSectionNumber == 0 ? 'is-active' : '',
                    currentSectionNumber > 0 ? 'is-completed' : '',
                  ]"
                >
                  <span class="question_progressTxt">{{
                    questionTexts.progress_suiminshukan
                  }}</span>
                  <span class="question_progressNum"
                    >{{ returnProgressBunshi }} /
                    {{ returnProgressBosuu }}</span
                  >
                  <span
                    class="question_progressBarBg"
                    :style="{
                      width:
                        String(
                          (this.returnProgressBunshi /
                            this.returnProgressBosuu) *
                            100
                        ) + '%',
                    }"
                  ></span>
                </div>
                <div
                  class="question_progressBarIn"
                  :class="[
                    currentSectionNumber == 1 ? 'is-active' : '',
                    currentSectionNumber > 1 ? 'is-completed' : '',
                  ]"
                >
                  <span class="question_progressTxt">{{
                    questionTexts.progress_seisansei
                  }}</span>
                  <span class="question_progressNum"
                    >{{ returnProgressBunshi }} /
                    {{ returnProgressBosuu }}</span
                  >
                  <span
                    class="question_progressBarBg"
                    :style="{
                      width:
                        String(
                          (this.returnProgressBunshi /
                            this.returnProgressBosuu) *
                            100
                        ) + '%',
                    }"
                  ></span>
                </div>

                <div
                  class="question_progressBarIn"
                  :class="[
                    currentSectionNumber == 2 ? 'is-active' : '',
                    currentSectionNumber > 2 ? 'is-completed' : '',
                  ]"
                >
                  <span class="question_progressTxt">{{
                    questionTexts.progress_nemuke
                  }}</span>
                  <span class="question_progressNum"
                    >{{ returnProgressBunshi }} /
                    {{ returnProgressBosuu }}</span
                  >
                  <span
                    class="question_progressBarBg"
                    :style="{
                      width:
                        String(
                          (this.returnProgressBunshi /
                            this.returnProgressBosuu) *
                            100
                        ) + '%',
                    }"
                  ></span>
                </div>

                <div
                  class="question_progressBarIn"
                  :class="[
                    currentSectionNumber == 3 ? 'is-active' : '',
                    currentSectionNumber > 3 ? 'is-completed' : '',
                  ]"
                >
                  <span class="question_progressTxt">{{
                    questionTexts.progress_hatarakikata
                  }}</span>
                  <span class="question_progressNum"
                    >{{ returnProgressBunshi }} /
                    {{ returnProgressBosuu }}</span
                  >
                  <span
                    class="question_progressBarBg"
                    :style="{
                      width:
                        String(
                          (this.returnProgressBunshi /
                            this.returnProgressBosuu) *
                            100
                        ) + '%',
                    }"
                  ></span>
                </div>
              </div>
            </div>

            <!-- 設問表示タイプ = 1 ラジオボタン-->
            <!-- type = 1であっても、実際はフロント側で表示を制御している設問に関してはホワイトリスト形式で除外-->
            <div
              v-if="
                currentQuestion.type == '1' &&
                  (currentSectionNumber != 0 ||
                    currentSectionQuestionNumber != 3) &&
                  (currentSectionNumber != 2 ||
                    currentSectionQuestionNumber != 1) &&
                  (currentSectionNumber != 3 ||
                    currentSectionQuestionNumber != 1) &&
                  (currentSectionNumber != 3 ||
                    currentSectionQuestionNumber != 0) &&
                  (currentSectionNumber != 0 ||
                    currentSectionQuestionNumber != 14) &&
                  currentQuestion['id'] != 2 &&
                  currentQuestion['id'] != 4 &&
                  currentQuestion['id'] != 6 &&
                  currentQuestion['id'] != 17 &&
                  currentQuestion['id'] != 18 &&
                  currentQuestion['id'] != 19 &&
                  currentQuestion['id'] != 20
              "
            >
              <v-row class="question_questionArea">
                <v-col cols="12" class="question_questionAreaIn">
                  <div class="question_txtArea">
                    <h2>
                      <!-- items(小問)が存在するか否かで、設問の表示方法を変更する -->
                      <!-- Q1の最初の設問 -->
                      <div
                        v-if="
                          (currentQuestion.id == 1) &
                            (currentQuestionItemsNumber == 1)
                        "
                      >
                        <span
                          class="question_sectionTxt"
                          style="margin-top:52px"
                          v-if="currentQuestion.items.length > 0"
                          >{{ currentQuestion.body }}</span
                        >
                        <span
                          class="question_questionTxt"
                          v-if="currentQuestion.items.length == 0"
                          >{{ currentQuestion.body }}</span
                        >
                      </div>
                      <!-- Q1の2番目の設問 -->
                      <div
                        v-if="
                          (currentQuestion.id == 1) &
                            (currentQuestionItemsNumber == 6)
                        "
                        style="margin-top:85px"
                      >
                        <span
                          class="question_sectionTxt"
                          v-if="currentQuestion.items.length > 0"
                          >{{ currentQuestion.body }}</span
                        >
                        <span
                          class="question_questionTxt"
                          v-if="currentQuestion.items.length == 0"
                          >{{ currentQuestion.body }}</span
                        >
                      </div>
                      <!-- それ以外 -->
                      <div
                        v-if="
                          !(
                            (currentQuestion.id == 1) &
                            (currentQuestionItemsNumber == 1)
                          ) &
                            !(
                              (currentQuestion.id == 1) &
                              (currentQuestionItemsNumber == 6)
                            )
                        "
                      >
                        <span
                          class="question_sectionTxt"
                          v-if="
                            !(
                              (currentQuestion.id == 21) &
                              (currentQuestionItemsNumber == 0)
                            ) &
                              !(
                                (currentQuestion.id == 5) &
                                (currentQuestionItemsNumber == 0)
                              ) &
                              !(
                                (currentQuestion.id == 7) &
                                (currentQuestionItemsNumber == 0)
                              ) &
                              !(
                                (currentQuestion.id == 8) &
                                (currentQuestionItemsNumber == 0)
                              ) &
                              !(
                                (currentQuestion.id == 10) &
                                (currentQuestionItemsNumber == 0)
                              )
                          "
                        >
                          {{ currentQuestion.body }}</span
                        >
                        <span
                          class="question_questionTxt"
                          v-if="currentQuestion.items.length == 0"
                          >{{ currentQuestion.body }}</span
                        >
                      </div>
                    </h2>
                    <h3
                      class="question_questionTxt"
                      v-if="currentQuestion.items.length > 0"
                    >
                      {{
                        currentQuestion.items[currentQuestionItemsNumber][
                          "body"
                        ]
                      }}
                    </h3>
                  </div>
                  <div class="question_illustArea">
                    <img
                      :src="'img/illust_q' + currentQuestion['id'] + '.svg'"
                      class="question_illust"
                    />
                  </div>
                </v-col>
              </v-row>
              <v-row class="question_answerArea">
                <v-col cols="12">
                  <span
                    v-for="(item, index) of currentQuestion.choices"
                    :key="item.id"
                  >
                    <button
                      :value="index"
                      :id="
                        'button-' +
                          currentQuestion['id'] +
                          currentQuestionItemsNumber +
                          index
                      "
                      v-on:click="clickChoiceBtn"
                      class="radio_label"
                    >
                      {{ item.body }}
                    </button>
                  </span>
                </v-col>
              </v-row>
            </div>

            <!-- Q2 -->
            <div v-if="currentQuestion['id'] == 2">
              <v-row class="question_questionArea">
                <v-col cols="12" class="question_questionAreaIn">
                  <div class="question_txtArea">
                    <h2>
                      {{ currentQuestion.body }}
                    </h2>
                    <p>
                      {{ questionTexts.q2_questionSub }}
                    </p>
                  </div>
                  <div class="question_illustArea">
                    <img
                      :src="'img/illust_q' + currentQuestion['id'] + '.svg'"
                      class="question_illust"
                    />
                  </div>
                </v-col>
              </v-row>
              <v-row class="question_answerArea">
                <v-col cols="12">
                  <span
                    v-for="(item, index) of currentQuestion.choices"
                    :key="item.id"
                  >
                    <button
                      :value="index"
                      :id="
                        'button-' +
                          currentQuestion['id'] +
                          currentQuestionItemsNumber +
                          index
                      "
                      v-on:click="clickChoiceBtn"
                      class="radio_label"
                    >
                      {{ item.body }}
                    </button>
                  </span>
                </v-col>
              </v-row>
            </div>
            <div v-if="currentQuestion['id'] == 18">
              <v-row class="question_questionArea">
                <v-col cols="12" class="question_questionAreaIn">
                  <div class="question_txtArea">
                    <h2>
                      <!-- items(小問)が存在するか否かで、設問の表示方法を変更する -->
                      <span
                        class="question_sectionTxt"
                        v-if="currentQuestion.items.length > 0"
                        >{{ currentQuestion.body }}</span
                      >
                      <span
                        class="question_questionTxt"
                        v-if="currentQuestion.items.length == 0"
                        >{{ currentQuestion.body }}</span
                      >
                    </h2>
                    <h3
                      class="question_questionTxt"
                      v-if="currentQuestion.items.length > 0"
                    >
                      {{
                        currentQuestion.items[currentQuestionItemsNumber][
                          "body"
                        ]
                      }}
                    </h3>
                  </div>
                  <div class="question_illustArea">
                    <img
                      :src="'img/illust_q' + currentQuestion['id'] + '.svg'"
                      class="question_illust"
                    />
                  </div>
                </v-col>
              </v-row>
              <v-row class="question_answerArea">
                <v-col cols="12">
                  <span
                    v-for="(item, index) of currentQuestion.choices"
                    :key="item.id"
                  >
                    <button
                      :value="index"
                      :id="
                        'button-' +
                          currentQuestion['id'] +
                          currentQuestionItemsNumber +
                          index
                      "
                      v-on:click="clickChoiceBtn"
                      class="radio_label"
                    >
                      {{ item.body }}
                    </button>
                  </span>
                </v-col>
              </v-row>
            </div>
            <!-- Q19 -->
            <div v-if="currentQuestion['id'] == 19">
              <v-row class="question_questionArea">
                <v-col cols="12" class="question_questionAreaIn">
                  <div class="question_txtArea">
                    <h2>
                      <!-- items(小問)が存在するか否かで、設問の表示方法を変更する -->
                      <span
                        class="question_sectionTxt"
                        v-if="currentQuestion.items.length > 0"
                        >{{ currentQuestion.body }}</span
                      >
                      <span
                        class="question_questionTxt"
                        v-if="currentQuestion.items.length == 0"
                        >{{ currentQuestion.body }}</span
                      >
                    </h2>
                    <h3
                      class="question_questionTxt"
                      v-if="currentQuestion.items.length > 0"
                    >
                      {{
                        currentQuestion.items[currentQuestionItemsNumber][
                          "body"
                        ]
                      }}
                    </h3>
                  </div>
                  <div class="question_illustArea">
                    <img
                      :src="'img/illust_q' + currentQuestion['id'] + '.svg'"
                      class="question_illust"
                    />
                  </div>
                </v-col>
              </v-row>
              <v-row class="question_answerArea">
                <v-col cols="12">
                  <div class="q19">
                    <v-select
                      :items="q19Items"
                      v-model="answer[0]"
                      class="textarea_inline"
                      dense
                      solo
                    ></v-select>
                    <span>{{ questionTexts.q19_subtext }}</span>
                  </div>
                  <button
                    class="btn_next"
                    v-on:click="nextQuestion"
                    :class="{ 'is-negative': !isAnswerd }"
                    v-if="confirmLookback == 0"
                  >
                    {{ questionTexts.next_button }}
                  </button>
                  <button
                    class="btn_next"
                    v-on:click="nextQuestion"
                    :class="{ 'is-negative': !isAnswerd }"
                    v-if="confirmLookback == 1"
                  >
                    {{ this.questionTexts.back_to_confirmation }}
                  </button>
                </v-col>
              </v-row>
            </div>
            <!-- Q20 -->
            <div v-if="currentQuestion['id'] == 20">
              <v-row class="question_questionArea">
                <v-col cols="12" class="question_questionAreaIn">
                  <div class="question_txtArea">
                    <h2>
                      <!-- items(小問)が存在するか否かで、設問の表示方法を変更する -->
                      <span
                        class="question_sectionTxt"
                        v-if="currentQuestion.items.length > 0"
                        >{{ currentQuestion.body }}</span
                      >
                      <span
                        class="question_questionTxt"
                        v-if="currentQuestion.items.length == 0"
                        >{{ currentQuestion.body }}</span
                      >
                    </h2>
                    <h3
                      class="question_questionTxt"
                      v-if="currentQuestion.items.length > 0"
                    >
                      {{
                        currentQuestion.items[currentQuestionItemsNumber][
                          "body"
                        ]
                      }}
                    </h3>
                  </div>
                  <div class="question_illustArea">
                    <img
                      :src="'img/illust_q' + currentQuestion['id'] + '.svg'"
                      class="question_illust"
                    />
                  </div>
                </v-col>
              </v-row>
              <v-row class="question_answerArea">
                <v-col cols="12">
                  <div class="q20">
                    <v-select
                      :items="q20Items"
                      v-model="answer[0]"
                      class="textarea_inline"
                      dense
                      solo
                    ></v-select>
                    <span>{{ this.questionTexts.q20_subtext }}</span>
                  </div>
                  <button
                    class="btn_next"
                    v-on:click="nextQuestion"
                    :class="{ 'is-negative': !isAnswerd }"
                    v-if="confirmLookback == 0"
                  >
                    {{ questionTexts.next_button }}
                  </button>
                  <button
                    class="btn_next"
                    v-on:click="nextQuestion"
                    :class="{ 'is-negative': !isAnswerd }"
                    v-if="confirmLookback == 1"
                  >
                    {{ this.questionTexts.back_to_confirmation }}
                  </button>
                </v-col>
              </v-row>
            </div>

            <!-- Q11 -->
            <div
              v-if="
                currentSectionNumber == 0 && currentSectionQuestionNumber == 14
              "
            >
              <v-row class="question_questionArea">
                <v-col cols="12" class="question_questionAreaIn">
                  <div class="question_txtArea">
                    <h2>
                      <span class="question_questionTxt" v-if="!q11Branch">{{
                        currentQuestion.body
                      }}</span>
                      <span class="question_questionTxt" v-if="q11Branch">{{
                        this.questionTexts.suiminshougei_question
                      }}</span>
                    </h2>
                  </div>
                  <div class="question_illustArea">
                    <img
                      :src="'img/illust_q' + currentQuestion['id'] + '.svg'"
                      class="question_illust"
                    />
                  </div>
                </v-col>
              </v-row>
              <v-row class="question_answerArea">
                <v-col cols="12" v-if="!q11Branch">
                  <button v-on:click="q11Branch = true" class="radio_label">
                    {{ currentQuestion.choices[0]["body"] }}
                  </button>
                  <!-- 確認画面表示時のロジック -->
                  <span v-if="this.confirmLookback == 0">
                    <button
                      :value="index"
                      v-on:click="
                        answer = 0;
                        gotoNext();
                      "
                      class="radio_label"
                    >
                      {{ currentQuestion.choices[1]["body"] }}
                    </button>
                  </span>

                  <span v-if="this.confirmLookback == 1">
                    <button
                      :value="index"
                      v-on:click="
                        answer = 0;
                        nextQuestion();
                      "
                      class="radio_label"
                    >
                      {{ this.questionTexts.nai }}
                    </button>
                  </span>
                </v-col>

                <v-col cols="12" v-if="q11Branch">
                  <div v-if="this.confirmLookback == 0">
                    <button
                      v-on:click="
                        answer = 1;
                        gotoNext(), (q11Branch = false);
                      "
                      class="radio_label"
                    >
                      {{ this.questionTexts.suimin_mukokyuu }}
                    </button>
                    <button
                      :value="index"
                      v-on:click="
                        answer = 2;
                        gotoNext(), (q11Branch = false);
                      "
                      class="radio_label"
                    >
                      {{ this.questionTexts.suimin_sonota }}
                    </button>
                  </div>
                  <!-- 確認画面表示時のロジック -->
                  <div v-if="this.confirmLookback == 1">
                    <button
                      v-on:click="
                        answer = 1;
                        nextQuestion(), (q11Branch = false);
                      "
                      class="radio_label"
                    >
                      {{ this.questionTexts.suimin_mukokyuu }}
                    </button>
                    <button
                      :value="index"
                      v-on:click="
                        answer = 2;
                        nextQuestion(), (q11Branch = false);
                      "
                      class="radio_label"
                    >
                      {{ this.questionTexts.suimin_sonota }}
                    </button>
                  </div>
                </v-col>
              </v-row>
            </div>
            <!-- Q15 -->
            <div
              v-if="
                currentSectionNumber == 3 && currentSectionQuestionNumber == 0
              "
            >
              <v-row class="question_questionArea">
                <v-col cols="12" class="question_questionAreaIn mt-6">
                  <div class="question_txtArea">
                    <h2>
                      <span class="question_questionTxt">{{
                        currentQuestion.body
                      }}</span>
                    </h2>
                    <p>
                      {{ questionTexts.q15_questionSub }} <br />{{
                        questionTexts.q15_questionSub2
                      }}
                    </p>
                  </div>
                  <div class="question_illustArea">
                    <img
                      :src="'img/illust_q' + currentQuestion['id'] + '.svg'"
                      class="question_illust"
                    />
                  </div>
                </v-col>
              </v-row>
              <v-row class="question_answerArea">
                <v-col cols="12">
                  <div class="q15">
                    <div>
                      {{ currentQuestion.items[0]["body"] }}
                      <v-select
                        :items="q15Items"
                        v-model="answer[0]"
                        class="textarea_inline-wide"
                        dense
                        solo
                      ></v-select>
                    </div>
                    <div>
                      {{ currentQuestion.items[1]["body"] }}
                      <div>
                        <v-select
                          :items="q15Items"
                          v-model="answer[1]"
                          class="textarea_inline-wide"
                          dense
                          solo
                        ></v-select>
                      </div>
                    </div>
                  </div>
                  <button
                    class="btn_next"
                    v-on:click="nextQuestion"
                    :class="{ 'is-negative': !isAnswerd }"
                    v-if="confirmLookback == 0"
                  >
                    {{ questionTexts.next_button }}
                  </button>
                  <button
                    class="btn_next"
                    v-on:click="nextQuestion"
                    :class="{ 'is-negative': !isAnswerd }"
                    v-if="confirmLookback == 1"
                  >
                    {{ this.questionTexts.back_to_confirmation }}
                  </button>
                </v-col>
              </v-row>
            </div>

            <!-- Q4 -->
            <div v-if="currentQuestion['id'] == 4">
              <v-row class="question_questionArea">
                <v-col cols="12" class="question_questionAreaIn">
                  <div class="question_txtArea">
                    <h2>
                      {{ currentQuestion.body }}
                    </h2>
                    <p>{{ questionTexts.q4_questionSub }}</p>
                  </div>
                  <div class="question_illustArea">
                    <img
                      :src="'img/illust_q' + currentQuestion['id'] + '.svg'"
                      class="question_illust"
                    />
                  </div>
                </v-col>
              </v-row>
              <v-row class="question_answerArea">
                <v-col cols="12">
                  <div
                    v-for="(item, index) of sections[currentSectionNumber]
                      .questions[7].items"
                    :key="item.index"
                    class="q16_item"
                  >
                    <p class="q16_question">{{ item.body }}</p>
                    <ul class="question_list">
                      <li>
                        <label
                          :for="'input-' + item.id + '-0'"
                          class="radio_label radio_label-narrow"
                          :class="{ 'is-pressed': answer[index] == 0 }"
                        >
                          <input
                            type="radio"
                            class="radio_input"
                            :name="'input-' + item.id"
                            value="0"
                            :id="'input-' + item.id + '-0'"
                            v-model="answer[index]"
                          />
                          {{ currentQuestion.choices[0]["body"] }}
                        </label>
                      </li>
                      <li>
                        <label
                          :for="'input-' + item.id + '-1'"
                          class="radio_label radio_label-narrow"
                          :class="{ 'is-pressed': answer[index] == 1 }"
                        >
                          <input
                            type="radio"
                            class="radio_input"
                            :name="'input-' + item.id"
                            value="1"
                            :id="'input-' + item.id + '-1'"
                            v-model="answer[index]"
                          />
                          {{ currentQuestion.choices[1]["body"] }}
                        </label>
                      </li>
                      <li>
                        <label
                          :for="'input-' + item.id + '-2'"
                          class="radio_label radio_label-narrow"
                          :class="{ 'is-pressed': answer[index] == 2 }"
                        >
                          <input
                            type="radio"
                            class="radio_input"
                            :name="'input-' + item.id"
                            value="2"
                            :id="'input-' + item.id + '-2'"
                            v-model="answer[index]"
                          />
                          {{ currentQuestion.choices[2]["body"] }}
                        </label>
                      </li>
                      <li>
                        <label
                          :for="'input-' + item.id + '-3'"
                          class="radio_label radio_label-narrow"
                          :class="{ 'is-pressed': answer[index] == 3 }"
                        >
                          <input
                            type="radio"
                            class="radio_input"
                            :name="'input-' + item.id"
                            value="3"
                            :id="'input-' + item.id + '-3'"
                            v-model="answer[index]"
                          />
                          {{ currentQuestion.choices[3]["body"] }}
                        </label>
                      </li>
                    </ul>
                  </div>
                  <div class="question_nextBtn">
                    <button
                      class="btn_next"
                      v-on:click="gotoNextFromQ16"
                      :class="{ 'is-negative': !isAnswerd }"
                      v-if="confirmLookback == 0"
                    >
                      {{ questionTexts.next_button }}
                    </button>
                    <button
                      class="btn_next"
                      v-on:click="nextQuestion"
                      :class="{ 'is-negative': !isAnswerd }"
                      v-if="confirmLookback == 1"
                    >
                      {{ this.questionTexts.back_to_confirmation }}
                    </button>
                  </div>
                </v-col>
              </v-row>
            </div>
            <!-- Q6 -->
            <div v-if="currentQuestion['id'] == 6">
              <v-row class="question_questionArea">
                <v-col cols="12" class="question_questionAreaIn">
                  <div class="question_txtArea">
                    <h2>
                      {{ currentQuestion.body }}
                    </h2>
                    <p>
                      {{ questionTexts.q6_questionSub }}
                    </p>
                  </div>
                  <div class="question_illustArea">
                    <img
                      :src="'img/illust_q' + currentQuestion['id'] + '.svg'"
                      class="question_illust"
                    />
                  </div>
                </v-col>
              </v-row>
              <v-row class="question_answerArea">
                <v-col cols="12">
                  <span
                    v-for="(item, index) of currentQuestion.choices"
                    :key="item.id"
                  >
                    <button
                      :value="index"
                      :id="
                        'button-' +
                          currentQuestion['id'] +
                          currentQuestionItemsNumber +
                          index
                      "
                      v-on:click="clickChoiceBtn"
                      class="radio_label"
                    >
                      {{ item.body }}
                    </button>
                  </span>
                </v-col>
              </v-row>
            </div>
            <!-- Q14 -->
            <div
              v-if="
                currentSectionNumber == 2 && currentSectionQuestionNumber == 1
              "
            >
              <v-row class="question_questionArea">
                <v-col cols="12" class="question_questionAreaIn mt-6">
                  <div class="question_txtArea">
                    <h2>
                      {{ currentQuestion.body }}
                    </h2>
                    <p>
                      {{ questionTexts.q14_questionSub }}
                    </p>
                  </div>
                  <div class="question_illustArea">
                    <img
                      :src="'img/illust_q' + currentQuestion['id'] + '.svg'"
                      class="question_illust"
                    />
                  </div>
                </v-col>
              </v-row>
              <v-row class="question_answerArea">
                <v-col cols="12">
                  <div
                    v-for="(item, index) of sections[currentSectionNumber]
                      .questions[1].items"
                    :key="item.index"
                    class="q16_item"
                  >
                    <p class="q16_question">{{ item.body }}</p>
                    <ul class="question_list">
                      <li>
                        <label
                          :for="'input-' + item.id + '-0'"
                          class="radio_label radio_label-narrow"
                          :class="{ 'is-pressed': answer[index] == 0 }"
                        >
                          <input
                            type="radio"
                            class="radio_input"
                            :name="'input-' + item.id"
                            value="0"
                            :id="'input-' + item.id + '-0'"
                            v-model="answer[index]"
                          />
                          {{ currentQuestion.choices[0]["body"] }}
                        </label>
                      </li>
                      <li>
                        <label
                          :for="'input-' + item.id + '-1'"
                          class="radio_label radio_label-narrow"
                          :class="{ 'is-pressed': answer[index] == 1 }"
                        >
                          <input
                            type="radio"
                            class="radio_input"
                            :name="'input-' + item.id"
                            value="1"
                            :id="'input-' + item.id + '-1'"
                            v-model="answer[index]"
                          />
                          {{ currentQuestion.choices[1]["body"] }}
                        </label>
                      </li>
                      <li>
                        <label
                          :for="'input-' + item.id + '-2'"
                          class="radio_label radio_label-narrow"
                          :class="{ 'is-pressed': answer[index] == 2 }"
                        >
                          <input
                            type="radio"
                            class="radio_input"
                            :name="'input-' + item.id"
                            value="2"
                            :id="'input-' + item.id + '-2'"
                            v-model="answer[index]"
                          />
                          {{ currentQuestion.choices[2]["body"] }}
                        </label>
                      </li>
                      <li>
                        <label
                          :for="'input-' + item.id + '-3'"
                          class="radio_label radio_label-narrow"
                          :class="{ 'is-pressed': answer[index] == 3 }"
                        >
                          <input
                            type="radio"
                            class="radio_input"
                            :name="'input-' + item.id"
                            value="3"
                            :id="'input-' + item.id + '-3'"
                            v-model="answer[index]"
                          />
                          {{ currentQuestion.choices[3]["body"] }}
                        </label>
                      </li>
                    </ul>
                  </div>
                  <div class="question_nextBtn">
                    <button
                      class="btn_next"
                      v-on:click="nextSection"
                      v-if="confirmLookback == 0"
                      :class="{ 'is-negative': !isAnswerd }"
                    >
                      {{ questionTexts.next_button }}
                    </button>
                    <button
                      class="btn_next"
                      v-on:click="nextQuestion"
                      v-if="confirmLookback == 1"
                      :class="{ 'is-negative': !isAnswerd }"
                    >
                      {{ this.questionTexts.back_to_confirmation }}
                    </button>
                  </div>
                </v-col>
              </v-row>
            </div>

            <!-- Q16 -->
            <div
              v-if="
                currentSectionNumber == 3 && currentSectionQuestionNumber == 1
              "
            >
              <v-row class="question_questionArea">
                <v-col cols="12" class="question_questionAreaIn">
                  <div class="question_txtArea">
                    <h2>{{ currentQuestion.body }}</h2>
                  </div>
                  <div class="question_illustArea">
                    <img
                      :src="'img/illust_q' + currentQuestion['id'] + '.svg'"
                      class="question_illust"
                    />
                  </div>
                </v-col>
              </v-row>
              <v-row class="question_answerArea">
                <v-col cols="12">
                  <div
                    v-for="(item, index) of sections[currentSectionNumber]
                      .questions[1].items"
                    :key="item.index"
                    class="q16_item"
                  >
                    <p class="q16_question">{{ item.body }}</p>
                    <ul class="question_list">
                      <li>
                        <label
                          :for="'input-' + item.id + '-0'"
                          class="radio_label radio_label-narrow"
                          :class="{ 'is-pressed': answer[index] == 0 }"
                        >
                          <input
                            type="radio"
                            class="radio_input"
                            :name="'input-' + item.id"
                            value="0"
                            :id="'input-' + item.id + '-0'"
                            v-model="answer[index]"
                          />
                          {{ currentQuestion.choices[0]["body"] }}
                        </label>
                      </li>
                      <li>
                        <label
                          :for="'input-' + item.id + '-1'"
                          class="radio_label radio_label-narrow"
                          :class="{ 'is-pressed': answer[index] == 1 }"
                        >
                          <input
                            type="radio"
                            class="radio_input"
                            :name="'input-' + item.id"
                            value="1"
                            :id="'input-' + item.id + '-1'"
                            v-model="answer[index]"
                          />
                          {{ currentQuestion.choices[1]["body"] }}
                        </label>
                      </li>
                      <li>
                        <label
                          :for="'input-' + item.id + '-2'"
                          class="radio_label radio_label-narrow"
                          :class="{ 'is-pressed': answer[index] == 2 }"
                        >
                          <input
                            type="radio"
                            class="radio_input"
                            :name="'input-' + item.id"
                            value="2"
                            :id="'input-' + item.id + '-2'"
                            v-model="answer[index]"
                          />
                          {{ currentQuestion.choices[2]["body"] }}
                        </label>
                      </li>
                      <li>
                        <label
                          :for="'input-' + item.id + '-3'"
                          class="radio_label radio_label-narrow"
                          :class="{ 'is-pressed': answer[index] == 3 }"
                        >
                          <input
                            type="radio"
                            class="radio_input"
                            :name="'input-' + item.id"
                            value="3"
                            :id="'input-' + item.id + '-3'"
                            v-model="answer[index]"
                          />
                          {{ currentQuestion.choices[3]["body"] }}
                        </label>
                      </li>
                    </ul>
                  </div>
                  <div class="question_nextBtn">
                    <button
                      class="btn_next"
                      v-on:click="gotoNextFromQ16"
                      v-if="confirmLookback == 0"
                      :class="{ 'is-negative': !isAnswerd }"
                    >
                      {{ questionTexts.next_button }}
                    </button>
                    <button
                      class="btn_next"
                      v-on:click="nextQuestion"
                      v-if="confirmLookback == 1"
                      :class="{ 'is-negative': !isAnswerd }"
                    >
                      {{ this.questionTexts.back_to_confirmation }}
                    </button>
                  </div>
                </v-col>
              </v-row>
            </div>

            <!-- 設問表示タイプ = 2 チェックボックス-->
            <div v-if="currentQuestion.type == '2'">
              <v-row class="question_questionArea">
                <v-col cols="12" class="question_questionAreaIn">
                  <div class="question_txtArea">
                    <h2>
                      <span
                        class="question_sectionTxt"
                        v-if="currentQuestion.items.length > 0"
                        >{{ currentQuestion.body }}</span
                      >
                      <span
                        class="question_questionTxt"
                        v-if="currentQuestion.items.length == 0"
                        >{{ currentQuestion.body }}</span
                      >
                    </h2>
                    <h3
                      class="question_questionTxt"
                      v-if="currentQuestion.items.length > 0"
                    >
                      {{
                        currentQuestion.items[currentQuestionItemsNumber][
                          "body"
                        ]
                      }}
                    </h3>
                  </div>
                  <div class="question_illustArea">
                    <img
                      :src="'img/illust_q' + currentQuestion['id'] + '.svg'"
                      class="question_illust"
                    />
                  </div>
                </v-col>
              </v-row>
              <v-row class="question_answerArea">
                <v-col cols="12">
                  <div class="checkbox_group">
                    <label
                      v-for="(item, index) of currentQuestion.choices"
                      :key="item.index"
                      :for="'input-' + index + 1"
                      class="checkbox_label"
                    >
                      <input
                        type="checkbox"
                        v-model="answer"
                        :value="index"
                        :id="'input-' + index + 1"
                        class="checkbox_input"
                      />
                      <span class="checkbox_labelTxt">{{ item["body"] }}</span>
                    </label>
                  </div>
                  <button
                    class="btn_next"
                    v-on:click="nextQuestion"
                    v-if="confirmLookback == 0"
                  >
                    {{ questionTexts.next_button }}
                  </button>
                  <button
                    class="btn_next"
                    v-on:click="nextQuestion"
                    v-if="confirmLookback == 1"
                  >
                    {{ this.questionTexts.back_to_confirmation }}
                  </button>
                </v-col>
              </v-row>
            </div>

            <!-- 設問表示タイプ = 3 整数値-->

            <!-- Q3 -->
            <div
              v-if="
                currentQuestion.type == '3' &&
                  currentSectionNumber == 0 &&
                  currentSectionQuestionNumber == 6
              "
            >
              <v-row class="question_questionArea">
                <v-col cols="12" class="question_questionAreaIn">
                  <div class="question_txtArea">
                    <h2>{{ currentQuestion.body }}</h2>
                  </div>
                  <div class="question_illustArea">
                    <img
                      :src="'img/illust_q' + currentQuestion['id'] + '.svg'"
                      class="question_illust"
                    />
                  </div>
                </v-col>
              </v-row>
              <div class="question_answerArea">
                <div class="q3_formBlk">
                  <div class="q3_box">
                    <h3>{{ questionTexts.q3_nedoko }}</h3>
                    <v-select
                      :items="q3Items1"
                      v-model="q3Bedin[0]"
                      class="textarea_inline"
                      dense
                      solo
                      hide-details
                    ></v-select>
                    <span>{{ questionTexts.q3_formZikan }}</span>
                    <v-select
                      :items="q3Items2"
                      v-model="q3Bedin[1]"
                      class="textarea_inline"
                      dense
                      solo
                      hide-details
                    ></v-select>
                    <span>{{ questionTexts.q3_fun }}</span>
                  </div>
                  <div class="q3_box">
                    <h3>{{ questionTexts.q3_nerunoni }}</h3>
                    <v-select
                      v-model="q3TimeToSleep"
                      class="textarea_inline"
                      :items="Array.from({ length: 1441 }, (_, i) => i)"
                      dense
                      solo
                      hide-details
                      style="width: 150px"
                    ></v-select
                    >{{ questionTexts.q3_formFun }}
                  </div>
                  <div class="q3_box">
                    <h3>{{ questionTexts.q3_kisyou }}</h3>
                    <v-select
                      :items="q3Items3"
                      v-model="q3Wakeup[0]"
                      class="textarea_inline"
                      dense
                      solo
                      hide-details
                    ></v-select>
                    <span>{{ questionTexts.q3_formZikan }}</span>
                    <v-select
                      :items="q3Items2"
                      v-model="q3Wakeup[1]"
                      class="textarea_inline"
                      dense
                      solo
                      hide-details
                    ></v-select>
                    <span>{{ questionTexts.q3_fun }}</span>
                  </div>
                </div>
                <div class="q3_answerBlk">
                  <div class="q3_answer-1">
                    <h3 class="q3_answer-2">
                      {{ questionTexts.q3_suiminzikan }}
                    </h3>
                    <p class="q3_answer-3">{{ q3CalcAnswer }}</p>
                  </div>
                  <div class="q3_answer-4">
                    <button
                      class="btn_next"
                      v-on:click="nextQuestion"
                      v-if="confirmLookback == 0"
                      :class="{
                        'is-negative':
                          this.answer[0] == 0 && this.answer[1] == 0,
                      }"
                      :disabled="this.answer[0] == 0 && this.answer[1] == 0"
                    >
                      {{ questionTexts.next_button }}
                    </button>
                    <button
                      class="btn_next"
                      v-on:click="nextQuestion"
                      v-if="confirmLookback == 1"
                      :disabled="this.answer[0] == 0 && this.answer[1] == 0"
                      :class="{
                        'is-negative':
                          this.answer[0] == 0 && this.answer[1] == 0,
                      }"
                    >
                      {{ this.questionTexts.back_to_confirmation }}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Q13 -->
            <div
              v-if="
                currentQuestion.type == '3' &&
                  currentSectionNumber == 2 &&
                  currentSectionQuestionNumber == 0
              "
            >
              <v-row class="question_questionArea">
                <v-col cols="12" class="question_questionAreaIn">
                  <div class="question_txtArea">
                    <h2>
                      <span class="question_questionTxt">{{
                        currentQuestion.body
                      }}</span>
                    </h2>
                    <p>{{ questionTexts.q17_questionSub }}</p>
                  </div>
                  <div class="question_illustArea">
                    <img
                      :src="'img/illust_q' + currentQuestion['id'] + '.svg'"
                      class="question_illust"
                    />
                  </div>
                </v-col>
              </v-row>
              <v-row class="question_answerArea">
                <v-col cols="12">
                  <div class="q13">
                    <span>
                      {{ questionTexts.q13_form_shuni }}
                      <v-select
                        :items="q13Items1"
                        v-model="q13Days"
                        class="textarea_inline"
                        dense
                        solo
                      ></v-select
                      >{{ questionTexts.q13_form_nichi }}
                    </span>
                    <span>
                      {{ questionTexts.q13_form_ichinichi }}
                      <v-select
                        :items="q13Items2"
                        v-model="q13Hour"
                        class="textarea_inline"
                        dense
                        solo
                      ></v-select
                      >{{ questionTexts.q13_form_zikankurai }}
                    </span>
                    <h3>
                      {{ questionTexts.q13_summary_shugoukei }}
                      <span class="q13_answer-1"
                        >{{ (answer = q13CalcAnswer) }}
                        {{ questionTexts.q13_summary_zikan }}</span
                      >{{ questionTexts.q13_summary_kurai }}
                    </h3>
                  </div>
                  <button
                    class="btn_next"
                    v-on:click="nextQuestion"
                    :class="{ 'is-negative': !isAnswerd }"
                    v-if="confirmLookback == 0"
                  >
                    {{ questionTexts.next_button }}
                  </button>
                  <button
                    class="btn_next"
                    v-on:click="nextQuestion"
                    :class="{ 'is-negative': !isAnswerd }"
                    v-if="confirmLookback == 1"
                  >
                    {{ this.questionTexts.back_to_confirmation }}
                  </button>
                </v-col>
              </v-row>
            </div>

            <!-- Q17 -->
            <div v-if="currentQuestion['id'] == 17">
              <v-row class="question_questionArea">
                <v-col cols="12" class="question_questionAreaIn">
                  <div class="question_txtArea">
                    <h2>
                      <span class="question_questionTxt">{{
                        currentQuestion.body
                      }}</span>
                    </h2>
                    <p>{{ questionTexts.q17_questionSub }}</p>
                  </div>
                  <div class="question_illustArea">
                    <img
                      :src="'img/illust_q' + currentQuestion['id'] + '.svg'"
                      class="question_illust"
                    />
                  </div>
                </v-col>
              </v-row>
              <v-row class="question_answerArea">
                <v-col cols="12">
                  {{ questionTexts.q17_shu }}
                  <v-select
                    :items="q17Items"
                    v-model="answer"
                    class="textarea_inline"
                    dense
                    solo
                  ></v-select
                  >{{ questionTexts.q17_nichiteido }}
                  <div class="question_nextBtn">
                    <button
                      class="btn_next"
                      v-on:click="updateCompleted"
                      :class="{ 'is-negative': !isAnswerd }"
                      v-if="confirmLookback == 0"
                    >
                      {{ this.questionTexts.go_to_confirmation }}
                    </button>
                    <button
                      class="btn_next"
                      v-on:click="nextQuestion"
                      :class="{ 'is-negative': !isAnswerd }"
                      v-if="confirmLookback == 1"
                    >
                      {{ this.questionTexts.back_to_confirmation }}
                    </button>
                  </div>
                </v-col>
              </v-row>
            </div>
            <!-- 設問表示タイプ = 4 VASE-->
            <div v-if="currentQuestion.type == '4'">
              <v-row class="question_questionArea">
                <v-col cols="12" class="question_questionAreaIn mt-10">
                  <div class="question_txtArea">
                    <h2>
                      <span class="question_questionTxt">{{
                        currentQuestion.body
                      }}</span>
                    </h2>
                    <p>
                      {{ questionTexts.q12_questionSub }}
                    </p>
                  </div>
                  <div class="question_illustArea">
                    <img
                      :src="'img/illust_q' + currentQuestion['id'] + '.svg'"
                      class="question_illust"
                    />
                  </div>
                </v-col>
              </v-row>
              <!-- Q12 -->
              <v-row class="question_answerArea">
                <v-col cols="12">
                  <div class="q12_answer">
                    <p>
                      <span class="q12_itemTtl">{{
                        currentQuestion.items[0]["body"]
                      }}</span>
                    </p>
                    <v-slider
                      dark
                      v-model="answer[0]"
                      class="input_range"
                      max="100"
                      min="0"
                      hide-details
                      thumb-label="always"
                    ></v-slider>
                  </div>
                  <div class="q12_answer">
                    <p>
                      <span class="q12_itemTtl">{{
                        currentQuestion.items[1]["body"]
                      }}</span>
                    </p>
                    <v-slider
                      dark
                      v-model="answer[1]"
                      class="input_range"
                      max="100"
                      min="0"
                      hide-details
                      thumb-label="always"
                    ></v-slider>
                  </div>
                  <div class="q12_answer">
                    <p>
                      <span class="q12_itemTtl">{{
                        currentQuestion.items[2]["body"]
                      }}</span>
                    </p>
                    <v-slider
                      dark
                      v-model="answer[2]"
                      class="input_range"
                      max="100"
                      min="0"
                      hide-details
                      thumb-label="always"
                    ></v-slider>
                  </div>
                  <div class="q12_answer">
                    <p>
                      <span class="q12_itemTtl">{{
                        currentQuestion.items[3]["body"]
                      }}</span>
                    </p>
                    <v-slider
                      dark
                      v-model="answer[3]"
                      class="input_range"
                      max="100"
                      min="0"
                      hide-details
                      thumb-label="always"
                    ></v-slider>
                  </div>
                  <button
                    class="btn_next"
                    v-on:click="gotoNextFromQ12"
                    :class="{ 'is-negative': !isAnswerd }"
                    v-if="confirmLookback == 0"
                  >
                    {{ questionTexts.next_button }}
                  </button>
                  <button
                    class="btn_next"
                    v-on:click="nextQuestion()"
                    :class="{ 'is-negative': !isAnswerd }"
                    v-if="confirmLookback == 1"
                  >
                    {{ this.questionTexts.back_to_confirmation }}
                  </button>
                </v-col>
              </v-row>
            </div>

            <div
              class="question_prev"
              v-if="sectionIsViwed != 0 && this.confirmLookback == 0"
            >
              <button
                class="btn_prev"
                v-on:click="prevQuestion"
                depressed
                v-if="
                  this.totalAnsweredQuestionItemsNumber != 0 &&
                    currentQuestionItemsNumber == 0 &&
                    currentSectionQuestionNumber != 0
                "
              >
                {{ questionTexts.button_back }}
              </button>
              <button
                class="btn_prev"
                v-on:click="prevQuestionItem"
                v-if="
                  this.totalAnsweredQuestionItemsNumber != 0 &&
                    currentQuestionItemsLength > 1 &&
                    currentQuestionItemsNumber > 0
                "
              >
                {{ questionTexts.button_back }}
              </button>
              <v-dialog v-model="saveDialog" persistent max-width="720">
                <template v-slot:activator="{ on }">
                  <button class="btn_prev" v-on:click="saveDialogToTrue()">
                    {{ questionTexts.button_autosave }}
                  </button>
                </template>
                <v-card>
                  <v-card-title class="headline">{{
                    questionTexts.auto_save_title
                  }}</v-card-title>
                  <v-card-text class="subtitle-1 font-weight-bold">
                    <br />{{ questionTexts.auto_save_text }}
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="grey darken-1"
                      text
                      @click="saveDialog = false"
                      >{{ questionTexts.auto_back_to_question }}</v-btn
                    >
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="(saveDialog = false), postQuestionProgress()"
                      >{{ questionTexts.auto_back_to_mytop }}</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>

            <v-dialog v-model="browseBackDialog" scrollable max-width="720">
              <v-card>
                <v-card-title class="headlineBrowseBack headline">{{
                  questionTexts.browse_back_title
                }}</v-card-title>
                <v-card-text class="subtitle-1 font-weight-bold">
                  <br />{{ questionTexts.browse_back_text_1 }}<br />
                  <div v-if="this.confirmLookback == 0">
                    {{ questionTexts.browse_back_text_2 }}
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="browseBackDialog = false"
                    >{{ questionTexts.browse_back_to_question }}</v-btn
                  >
                  <v-btn
                    color="grey darken-1"
                    text
                    @click="(browseBackDialog = false), browseBackToMytop()"
                    >{{ questionTexts.browse_back_to_mytop }}</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </span>
          <!-- メイン表示エリアここまで -->
        </keep-alive>
      </transition>

      <!-- 開発用デバッグ表示エリア(isShowDebugger = 1で表示) -->
      <!-- <div class="question_debugger">
        <v-btn
          @click="isShowDebugger = !isShowDebugger"
          class="question_debuggerBtn"
          >debug</v-btn
        >
        <div
        >
          <p>
            言語(getLanguage)
            {{ getLanguage }}
            言語(la)
            {{ la }}
            q11branch
            {{ progressActive }}
            規約ページ
            {{ currentSectionNumber }}
            途中保存結果
            <span>{{ $route.params.questionAnswerProgress }}</span
            >/ セクション <span>{{ currentSectionNumber + 1 }}</span
            >/
            <span>{{ sections.length }}</span>
          </p>
          <p>
            設問
            <span>{{ currentSectionQuestionNumber + 1 }}</span
            >/
            <span>{{ currentSectionQuestionsLength }}</span>
          </p>
          <p>
            小問内
            <span>{{ currentQuestionItemsNumber + 1 }}</span
            >/
            <span>{{ currentQuestionItemsLength }}</span>
          </p>
          <p>再回答ステータス confirmLookback</p>
          <p>{{ confirmLookback }}</p>
          <p>回答状況 completed</p>
          <p>{{ completed }}</p>
          <p>回答済みの設問 answerConfirm</p>
          <p>{{ answerConfirm }}</p>
          <p>現在の質問の回答 answer</p>
          <p>{{ answer }}</p>
          <p>回答したか isAnswerd</p>
          <p>{{ isAnswerd }}</p>
          <p>これまでの回答結果 allAnswers</p>
          <p>{{ allAnswers }}</p>
          <p>セッション画面の閲覧有無 sectionIsViwed</p>
          <p>{{ sectionIsViwed }}</p>
          <p>現在のセクションの設問数 currentSectionQuestionsLength</p>
          <p>現在のセクション currentSection</p>
          <p>{{ currentSectionQuestionsLength }}</p>
          <p>現在回答中のセクション currentSectionNumber</p>
          <p>{{ currentSectionNumber + 1 }}</p>
          <p>現在回答中の質問 currentQuestion</p>
          <p>{{ currentQuestion }}</p>
          <p>現在回答中の質問本文 currentQuestion["body"]</p>
          <p>{{ currentQuestion["body"] }}</p>
          <p>回答状況(質問) currentSectionQuestionNumber</p>
          <p>{{ currentSectionQuestionNumber }}</p>
          <p>回答状況(小問) currentQuestionItemsNumber</p>
          <p>{{ currentQuestionItemsNumber }}</p>
          <p>回答中質問の小問数 currentQuestionItemsLength</p>
          <p>{{ currentQuestionItemsLength }}</p>
          <p>現在のログイン状況</p>
          <p>{{ getLoginState }}</p>
          <p>現在ログインしているユーザーID</p>
          <p>{{ getLoginUserId }}</p>
          <p>現在実行中の診断ID</p>
          <p>{{ getCurrentDiagnosisId }}</p>
          <p>アクセストークン</p>
          <p>{{ getAccessToken }}</p>
          <p>Q11</p>
          <p>{{ q11Branch }}</p>
          {{ calcCompletedQuestions }}
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import { Auth } from "aws-amplify";
import axios from "axios";
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";
import Profile from "./Profile";
import TermsText from "./TermsText";
import TermsTextEn from "./TermsTextEn";
import TermsTextCh from "./TermsTextCh";
import QuestionTextsJa from "../assets/questionTextsJa";
import QuestionTextsEn from "../assets/questionTextsEn";
import QuestionTextsCh from "../assets/questionTextsCh";
import { datadogRum } from "@datadog/browser-rum";

export default {
  watch: {
    // eslint-disable-next-line
    apiConfirmResponse: function(before, after) {
      this.answerConfirm = after;
    },
    returnGetLanguage() {
      if (this.getLanguage == "日本語") {
        this.questionTexts = QuestionTextsJa;
        this.la = "ja";
      } else if (this.getLanguage == "English") {
        this.questionTexts = QuestionTextsEn;
        this.la = "en";
      } else if (this.getLanguage == "中文") {
        this.questionTexts = QuestionTextsCh;
        this.la = "ch";
      }
      axios
        .get("/questions", {
          headers: { Authorization: this.getAccessToken },
          params: {
            la: this.la,
          },
        })
        .then((response) => {
          this.sections = response.data;
        });
    },
  },
  // eslint-disable-next-line
  beforeRouteLeave(to, from, next) {
    // 途中保存ダイアログ or 診断結果閲覧で別ページ遷移時はそのまま実行
    if (this.backToMytop == true || to["name"] == "result") {
      return next();
    }
    this.browseBackDialog = true;
  },

  beforeMount() {
    window.addEventListener("beforeunload", (event) => {
      if (this.welcomePageIsViewed == 1) {
        event.preventDefault();
        // Chrome requires returnValue to be set.
        event.returnValue = "";
      }
    });

    if (this.getLanguage == "日本語") {
      this.questionTexts = QuestionTextsJa;
      this.la = "ja";
    } else if (this.getLanguage == "English") {
      this.questionTexts = QuestionTextsEn;
      this.la = "en";
    } else if (this.getLanguage == "中文") {
      this.questionTexts = QuestionTextsCh;
      this.la = "ch";
    }
    // questionsに遷移したタイミングで、設問情報を取得
    axios
      .get("/questions", {
        headers: { Authorization: this.getAccessToken },
        params: {
          la: this.la,
        },
      })
      .then((response) => {
        this.sections = response.data;
        // 設問取得後、途中保存結果を取得
        axios
          .get("/questions/progress", {
            params: {
              userName: this.user["username"],
              isComplete: 1,
            },
            headers: { Authorization: this.getAccessToken },
            data: {},
          })
          .then((response) => {
            this.questionAnswerProgress = response.data;
            if (this.questionAnswerProgress != false) {
              this.currentSectionNumber =
                this.questionAnswerProgress["question_section_id"] - 1;
              this.currentSectionQuestionNumber =
                this.questionAnswerProgress["question_order"] - 1;
              // 途中から開始時は、直接設問に飛ばす
              this.sectionIsViwed = 1;
              this.progressActive = 0;
            }
          })
          .catch((err) => {
            (this.errored = true), (this.error = err);
          });
      })
      .catch((err) => {
        (this.errored = true), (this.error = err);
      });
  },
  created() {
    Auth.currentAuthenticatedUser().then((user) => {
      this.user = user;
    });

    // Question遷移時にアクセストークンを取得する
    Auth.currentSession()
      // eslint-disable-next-line
      .then((data) => {
        // eslint-disable-next-line
        store.commit("setValueToAccessToken", data["accessToken"]["jwtToken"]);
      })
      .catch((error) => {
        error;
      });

    // Question遷移時にユーザープロフィールを取得する
    axios
      .get("/users/profile", {
        params: { userName: this.getLoginUserId },
        headers: { Authorization: this.getAccessToken },
      })
      .then((response) => {
        // eslint-disable-next-line
        store.commit("setValueToLoginUserInfo", response["data"]);
        this.hasProfile = this.getLoginUserInfo["is_profile_entered"];
      })
      .catch((err) => {
        (this.errored = true), (this.error = err);
      });
  },
  data() {
    return {
      la: this.getLanguage,
      questionTexts: "",
      browseBackDialog: false,
      reloadDialog: false,
      backToMytop: false,
      progressActive: 1,
      user: false,
      questionAnswerProgress: false,
      saveDialog: false,
      currentSectionNumber: 0,
      currentSectionQuestionNumber: 0,
      currentQuestionItemsNumber: 0,
      totalAnsweredQuestionItemsNumber: 0,
      sections: {},
      answer: [],
      welcomePageIsViewed: 0,
      isAgreed: false,
      sectionIsViwed: 0,
      allAnswers: {},
      index: null,
      completed: false,
      confirmLookback: false,
      questionStructure: [8, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      q3Bedin: [],
      q3TimeToSleep: "",
      q3Wakeup: [],
      q3Items1: [
        21,
        22,
        23,
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
      ],
      q3Items2: [0, 10, 20, 30, 40, 50],
      q3Items3: [
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        0,
        1,
        2,
        3,
        4,
      ],
      q3Data: [],
      s3IsDisabled: true,
      q11Branch: false,
      q12Items: [...Array(101).keys()],
      q13Hour: "",
      q13Days: "",
      q13Items1: [...Array(8).keys()],
      q13Items2: [...Array(25).keys()],
      q15Items: [...Array(25).keys()],
      q17Items: [...Array(8).keys()],
      isSmoking: false,
      q19Items: [...Array(50).keys()],
      q19Cigarette: 0,
      q20Items: [...Array(40).keys()],
      q20Year: 0,
      q21Answer: "0",
      answeredInCurrentQuestion: 0,
      currentSectionItemsLength: 0,
      isShowDebugger: false,
      isTransition: false,
      hasProfile: "",
      profileTitle: "まずは、あなたのプロフィールを教えてください。",
      answerConfirm: [],
      apiConfirmResponse: [],
      answeredQuestionsNum: 0,
    };
  },
  methods: {
    ...mapMutations(["setValueToCurrentDiagnosisId", "setValueToLanguage"]),
    browseBackToMytop() {
      this.backToMytop = true;
      this.toMytopPath();
    },
    saveDialogToTrue() {
      this.saveDialog = true;
    },
    setBackToMyTopToTrue() {
      this.backToMytop = true;
    },
    postQuestionProgress() {
      axios
        .post(
          "/questions/progress",
          {
            userName: this.getLoginUserId,
            questionId: this.currentQuestion["id"],
          },
          {
            headers: { Authorization: this.getAccessToken },
            data: {},
          }
        )
        // eslint-disable-next-line no-unused-vars
        .then((response) => {
          this.backToMytop = true;
          this.toMytopPath();
        })
        .catch((err) => {
          (this.errored = true), (this.error = err);
        });
    },
    postCurrentAnswer() {
      // １ページに複数設問時の送信ロジック
      if (
        this.currentQuestion["id"] == 4 ||
        this.currentQuestion["id"] == 12 ||
        this.currentQuestion["id"] == 14 ||
        this.currentQuestion["id"] == 15 ||
        this.currentQuestion["id"] == 16
      ) {
        for (var cnt in this.answer) {
          let postDiagnosisId = this.getCurrentDiagnosisId;
          axios
            .post(
              "/questions",
              {
                diagnosisId: postDiagnosisId,
                questionId: this.currentQuestion["id"],
                questionItemId: this.currentQuestion["items"][cnt]["id"],
                body: this.currentAnswer[cnt],
              },
              {
                headers: { Authorization: this.getAccessToken },
                data: {},
              }
            )
            // eslint-disable-next-line no-unused-vars
            .then((response) => {
              this.getConfirmAnswer();
            })
            .catch((err) => {
              (this.errored = true), (this.error = err);
            });
        }
        cnt = 0;
        // その他の設問時の送信ロジック
      } else {
        let postDiagnosisId = this.getCurrentDiagnosisId;
        axios
          .post(
            "/questions",
            {
              diagnosisId: postDiagnosisId,
              questionId: this.currentQuestion["id"],
              questionItemId: this.currentQuestionItemsId,
              body: this.currentAnswer.toString(),
            },
            {
              headers: { Authorization: this.getAccessToken },
              data: {},
            }
          )
          // eslint-disable-next-line no-unused-vars
          .then((response) => {
            this.getConfirmAnswer();
          })
          .catch((err) => {
            (this.errored = true), (this.error = err);
          });
      }
    },
    postCurrentAnswerQ17() {
      axios
        .post(
          "/questions",
          {
            diagnosisId: this.getCurrentDiagnosisId,
            questionId: this.currentQuestion["id"],
            questionItemId: this.currentQuestionItemsId,
            body: this.currentAnswer.toString(),
          },
          {
            headers: { Authorization: this.getAccessToken },
            data: {},
          }
        )
        // eslint-disable-next-line no-unused-vars
        .then((response) => {
          (this.sectionIsViwed = 0), (this.currentSectionQuestionNumber = 0);
          this.currentQuestionItemsNumber = 0;
          this.sectionIsViwed = 0;
          this.totalAnsweredQuestionNumber++;
          this.currentSectionNumber = 0;
          this.answeredInCurrentQuestion = 0;
          this.currentSectionItemsLength = 0;
          (this.completed = 1), this.getConfirmAnswer();
        })
        .catch((err) => {
          (this.errored = true), (this.error = err);
        });
    },
    viewedWelcome() {
      if (this.answer && this.isAgreed) {
        axios
          .post(
            "/diagnosis",
            {
              accessToken: this.getAccessToken,
            },
            {
              headers: { Authorization: this.getAccessToken },
              data: {},
            }
          )
          // eslint-disable-next-line no-unused-vars
          .then((response) => {
            // eslint-disable-next-line no-unused-var
            this.$store.commit(
              "setValueToCurrentDiagnosisId",
              response["data"]
            );
          })
          .catch((err) => {
            (this.errored = true), (this.error = err);
          });
        this.welcomePageIsViewed = 1;
      }
    },
    viewedSection() {
      this.sectionIsViwed = 1;
      this.countSectionQuestions();
      this.answerLength = this.answerLength;
    },
    clickChoiceBtn(event) {
      this.answer = Number(event.target.value);
      setTimeout(this.gotoNext, 100);
    },
    updateCompleted() {
      if (this.isAnswerd) {
        this.postCurrentAnswerQ17();
      }
    },
    getConfirmAnswer() {
      // 回答内容を取得
      axios
        .get("/results/diagnoses/confirm", {
          params: {
            diagnosisId: this.getCurrentDiagnosisId,
          },
          headers: { Authorization: this.getAccessToken },
          data: {},
        })
        .then((response) => {
          this.apiConfirmResponse.splice(0);
          this.apiConfirmResponse.push(response.data);
          // 全問への回答が完了した場合は、完了時刻を更新する
          if (this.calcCompletedQuestions == 21) {
            this.updateCompletedAt();
          }
        })
        .catch((err) => {
          (this.errored = true), (this.error = err);
        });
    },
    updateCompletedAt() {
      // 回答完了時刻を更新
      axios
        .put("/diagnosis", {
          params: {
            diagnosisId: this.getCurrentDiagnosisId,
          },
          headers: { Authorization: this.getAccessToken },
          data: {},
        })
        .catch((err) => {
          (this.errored = true), (this.error = err);
        });
    },
    backToQuestion(sectionNumber, questionNumber) {
      this.currentQuestionItemsNumber = 0;
      this.answerLength = this.answerLength;
      this.confirmLookback = 1;
      this.sectionIsViwed = 1;
      this.currentSectionNumber = sectionNumber;
      this.currentSectionQuestionNumber = questionNumber;
      axios
        .get("/questions/current", {
          headers: { Authorization: this.getAccessToken },
          params: {
            diagnosisId: this.getCurrentDiagnosisId,
            questionId: this.currentQuestion["id"],
          },
        })
        .then((response) => {
          // eslint-disable-next-line
          console.log(response);
          if (response["data"]["joined_answer"].includes(",")) {
            this.answer = response["data"]["joined_answer"].split(",");
          } else {
            if (response["data"]["question_id"] == 9) {
              this.answer = [response["data"]["joined_answer"]];
            } else {
              this.answer = Number(response["data"]["joined_answer"]);
            }
          }
        });
      this.scrollTop();
    },
    gotoNext() {
      // 喫煙経験がない場合の分岐
      // 喫煙に関わる回答の3問をskipする
      if (
        this.currentQuestion["id"] == 18 &&
        (this.answer == 1 || this.answer == 2)
      ) {
        this.isTransition = true;
        setTimeout(this.toggleTransition, 500);
        if (this.isAnswerd && this.confirmLookback == 1) {
          this.postCurrentAnswer();
          this.confirmLookback = 0;
          this.sectionIsViwed = 0;
          this.scrollTop();
        } else {
          this.allAnswers[this.currentSectionQuestionNumber] = this.answer;
          this.postCurrentAnswer();
          this.answer = [];
          this.currentQuestionItemsNumber = 0;
          this.totalAnsweredQuestionItemsNumber++,
            this.currentSectionQuestionNumber++;
          this.answeredInCurrentQuestion++;
          this.scrollTop();

          this.answer = this.q19Cigarette;
          this.allAnswers[this.currentSectionQuestionNumber] = this.answer;
          this.postCurrentAnswer();
          this.answer = [];
          this.currentQuestionItemsNumber = 0;
          this.totalAnsweredQuestionItemsNumber++,
            this.currentSectionQuestionNumber++;
          this.answeredInCurrentQuestion++;
          this.scrollTop();

          this.answer = this.q20Year;
          this.allAnswers[this.currentSectionQuestionNumber] = this.answer;
          this.postCurrentAnswer();
          this.answer = [];
          this.currentQuestionItemsNumber = 0;
          this.totalAnsweredQuestionItemsNumber++,
            this.currentSectionQuestionNumber++;
          this.answeredInCurrentQuestion++;
          this.scrollTop();

          this.answer = this.q21Answer;
          this.allAnswers[this.currentSectionQuestionNumber] = this.answer;
          this.postCurrentAnswer();
          this.answer = [];
          this.currentQuestionItemsNumber = 0;
          this.totalAnsweredQuestionItemsNumber++,
            this.currentSectionQuestionNumber++;
          this.answeredInCurrentQuestion++;
          this.scrollTop();
        }
      } else if (this.isAnswerd || this.currentQuestion["id"] == 9) {
        this.isTransition = true;
        setTimeout(this.toggleTransition, 500);
        if (
          this.currentSectionQuestionNumber ==
            this.currentSectionQuestionsLength - 1 &&
          this.welcomePageIsViewed == 1
        ) {
          if (
            this.sections[this.currentSectionNumber].questions[
              this.currentSectionQuestionNumber
            ].items.length > 0
          ) {
            if (
              this.currentQuestionItemsNumber !=
              this.currentQuestionItemsLength - 1
            ) {
              this.nextQuestionItem();
            } else {
              this.nextSection();
            }
          } else {
            this.nextSection();
          }
        } else if (
          (this.currentQuestionItemsLength == 0 &&
            this.sectionIsViwed == 1 &&
            this.currentSectionQuestionNumber !=
              this.currentSectionQuestionsLength - 1) ||
          (this.currentQuestionItemsNumber ==
            this.currentQuestionItemsLength - 1 &&
            this.currentQuestionItemsLength > 0 &&
            this.sectionIsViwed == 1)
        ) {
          this.nextQuestion();
        } else if (
          this.currentQuestionItemsNumber !=
            this.currentQuestionItemsLength - 1 &&
          this.currentQuestionItemsLength > 0 &&
          this.sectionIsViwed == 1
        ) {
          this.nextQuestionItem();
        }
      }
    },
    toggleTransition() {
      this.isTransition = false;
    },
    gotoNextFromQ12() {
      if (
        this.answer[0] != null &&
        this.answer[1] != null &&
        this.answer[2] != null &&
        this.answer[3] != null
      ) {
        this.nextSection();
      }
    },
    gotoNextFromQ13() {
      if (this.answer[0] != null && this.answer[1] != null) {
        this.nextQuestion();
      }
    },
    gotoNextFromQ16() {
      if (this.answer.length != 0) {
        this.nextQuestion();
      }
    },
    nextSection() {
      if (this.isAnswerd || this.currentQuestion["id"] == 9) {
        this.allAnswers[this.currentSectionQuestionNumber] = this.answer;
        this.postCurrentAnswer();
        this.answer = [];
        this.currentSectionQuestionNumber = 0;
        this.currentQuestionItemsNumber = 0;
        this.sectionIsViwed = 0;
        this.totalAnsweredQuestionNumber++;
        this.currentSectionNumber++;
        this.answeredInCurrentQuestion = 0;
        this.currentSectionItemsLength = 0;
        this.countSectionQuestions();
        this.answerLength = this.answerLength;
        this.scrollTop();
      }
    },
    nextQuestion() {
      if (this.currentQuestion["id"] == 3) {
        // 2: 睡眠時間の送信
        axios
          .post(
            "/questions",
            {
              diagnosisId: this.getCurrentDiagnosisId,
              questionId: this.currentQuestion["id"],
              questionItemId: 2,
              body: this.answer[0],
            },
            {
              headers: { Authorization: this.getAccessToken },
              data: {},
            }
          )
          // eslint-disable-next-line no-unused-vars
          .then((response) => {});
        // 3: 寝床についた時間(H)の送信
        axios
          .post(
            "/questions",
            {
              diagnosisId: this.getCurrentDiagnosisId,
              questionId: this.currentQuestion["id"],
              questionItemId: 3,
              body: this.q3Bedin?.[0],
            },
            {
              headers: { Authorization: this.getAccessToken },
              data: {},
            }
          )
          // eslint-disable-next-line no-unused-vars
          .then((response) => {});
        // 4: 寝床についた時間(M)の送信
        axios
          .post(
            "/questions",
            {
              diagnosisId: this.getCurrentDiagnosisId,
              questionId: this.currentQuestion["id"],
              questionItemId: 4,
              body: this.q3Bedin?.[1],
            },
            {
              headers: { Authorization: this.getAccessToken },
              data: {},
            }
          )
          // eslint-disable-next-line no-unused-vars
          .then((response) => {});
        // 5: 寝るのにかかった時間の送信
        axios
          .post(
            "/questions",
            {
              diagnosisId: this.getCurrentDiagnosisId,
              questionId: this.currentQuestion["id"],
              questionItemId: 5,
              body: this.answer[1],
            },
            {
              headers: { Authorization: this.getAccessToken },
              data: {},
            }
          )
          // eslint-disable-next-line no-unused-vars
          .then((response) => {});
        // 6: 起きた時間(H)
        axios
          .post(
            "/questions",
            {
              diagnosisId: this.getCurrentDiagnosisId,
              questionId: this.currentQuestion["id"],
              questionItemId: 6,
              body: this.q3Wakeup?.[0],
            },
            {
              headers: { Authorization: this.getAccessToken },
              data: {},
            }
          )
          // eslint-disable-next-line no-unused-vars
          .then((response) => {});
        // 7: 起きた時間(M)
        axios
          .post(
            "/questions",
            {
              diagnosisId: this.getCurrentDiagnosisId,
              questionId: this.currentQuestion["id"],
              questionItemId: 7,
              body: this.q3Wakeup?.[1],
            },
            {
              headers: { Authorization: this.getAccessToken },
              data: {},
            }
          )
          // eslint-disable-next-line no-unused-vars
          .then((response) => {});
      }

      if (
        (this.isAnswerd && this.confirmLookback == 1) ||
        (this.confirmLookback == 1 && this.currentQuestion["id"] == 9)
      ) {
        this.postCurrentAnswer();
        this.confirmLookback = 0;
        this.sectionIsViwed = 0;
        this.scrollTop();
      } else {
        if (
          this.isAnswerd ||
          this.currentQuestion["id"] == 9 ||
          this.currentQuestion["id"] == 12
        ) {
          this.allAnswers[this.currentSectionQuestionNumber] = this.answer;
          this.postCurrentAnswer();
          this.answer = [];
          this.currentQuestionItemsNumber = 0;
          this.totalAnsweredQuestionItemsNumber++,
            this.currentSectionQuestionNumber++;
          this.answeredInCurrentQuestion++;
          this.scrollTop();
        }
      }
    },
    nextQuestionItem() {
      this.postCurrentAnswer();
      this.answer = [];
      this.allAnswers[this.currentSectionQuestionNumber] = this.answer;
      this.totalAnsweredQuestionNumber++;
      this.totalAnsweredQuestionItemsNumber++,
        this.currentQuestionItemsNumber++;
      this.answeredInCurrentQuestion++;
      this.answerLength = this.answerLength;
    },
    prevQuestion() {
      if (this.currentQuestion["id"] == 11 && this.q11Branch) {
        this.q11Branch = false;
      } else if (
        this.currentQuestion["id"] == 2 &&
        (this.allAnswers[1] == 1 || this.allAnswers[1] == 2)
      ) {
        // 喫煙の質問をないと答えて設問をskipした人は、前に戻るを押した時に、喫煙の質問までもどす
        // 4問戻す
        this.answeredInCurrentQuestion--;
        this.totalAnsweredQuestionItemsNumber--;
        this.currentSectionQuestionNumber--;

        this.answeredInCurrentQuestion--;
        this.totalAnsweredQuestionItemsNumber--;
        this.currentSectionQuestionNumber--;

        this.answeredInCurrentQuestion--;
        this.totalAnsweredQuestionItemsNumber--;
        this.currentSectionQuestionNumber--;

        this.answeredInCurrentQuestion--;
        this.totalAnsweredQuestionItemsNumber--;
        this.currentSectionQuestionNumber--;

        this.answer = this.allAnswers[this.currentSectionQuestionNumber];

        // 遷移先の設問が小問を持つときは最後の小問を表示
        this.currentQuestionItemsNumber =
          this.questionStructure[this.currentQuestion["id"] - 1] > 1
            ? this.questionStructure[this.currentQuestion["id"] - 1] - 1
            : 0;
      } else {
        this.answeredInCurrentQuestion--;
        this.totalAnsweredQuestionItemsNumber--;
        this.currentSectionQuestionNumber--;

        this.answer = this.allAnswers[this.currentSectionQuestionNumber];
        if (this.currentQuestion["id"] == 15) {
          this.answer = [
            this.q15Items[this.answer[0]],
            this.q15Items[this.answer[1]],
          ];
        }

        // 遷移先の設問が小問を持つときは最後の小問を表示
        this.currentQuestionItemsNumber =
          this.questionStructure[this.currentQuestion["id"] - 1] > 1
            ? this.questionStructure[this.currentQuestion["id"] - 1] - 1
            : 0;
      }
    },
    prevQuestionItem() {
      if (this.currentQuestion["id"] != 11 && this.q11Branch) {
        this.q11Branch = false;
      } else {
        if (this.currentQuestionItemsNumber == 0) {
          this.prevQuestion();
        } else {
          this.currentQuestionItemsNumber--;
        }
        this.answeredInCurrentQuestion--;
        this.totalAnsweredQuestionItemsNumber--;
      }
    },
    toResultPath() {
      if (this.isAnswerd) {
        this.allAnswers[this.currentSectionQuestionNumber] = this.answer + 1;
        this.$router.push("/result");
      }
    },
    toMytopPath() {
      this.$router.push("/mytop");
    },
    countSectionQuestions() {
      var currentSection = this.sections[this.currentSectionNumber];
      for (var i = 0; i < currentSection.questions.length; i++) {
        if (currentSection.questions[i].items.length > 0) {
          for (var j = 0; j < currentSection.questions[i].items.length; j++) {
            this.currentSectionItemsLength++;
          }
        } else {
          this.currentSectionItemsLength++;
        }
      }
    },
    calcQ3(bedin, wakeup, time) {
      this.answer = [
        0, // 分単位の睡眠時間
        0, // 寝つくまでの時間
      ];
      // 入力値の存在チェック (undefined だけでなく、空文字やnullもチェック)
      if (
        bedin?.[0] == null ||
        bedin?.[0] === "" ||
        bedin?.[1] == null ||
        bedin?.[1] === "" ||
        wakeup?.[0] == null ||
        wakeup?.[0] === "" ||
        wakeup?.[1] == null ||
        wakeup?.[1] === "" ||
        time == null ||
        time === ""
      ) {
        return (
          "--" +
          this.questionTexts.q3_zikan +
          "--" +
          this.questionTexts.q3_formFun
        );
      }

      // 入力値の型変換と範囲チェック (数値に変換できない、または範囲外の場合エラー)
      const bedinHour = parseInt(bedin[0]);
      const bedinMin = parseInt(bedin[1]);
      const wakeupHour = parseInt(wakeup[0]);
      const wakeupMin = parseInt(wakeup[1]);
      const sleepTime = parseInt(time);

      if (
        isNaN(bedinHour) ||
        bedinHour < 0 ||
        bedinHour > 23 ||
        isNaN(bedinMin) ||
        bedinMin < 0 ||
        bedinMin > 59 ||
        isNaN(wakeupHour) ||
        wakeupHour < 0 ||
        wakeupHour > 23 ||
        isNaN(wakeupMin) ||
        wakeupMin < 0 ||
        wakeupMin > 59 ||
        isNaN(sleepTime) ||
        sleepTime < 0 ||
        sleepTime > 1440
      ) {
        this.q3TimeToSleep = 0;
        this.answer = [
          0, // 分単位の睡眠時間
          0, // 寝つくまでの時間
        ];
        return (
          "--" +
          this.questionTexts.q3_zikan +
          "--" +
          this.questionTexts.q3_formFun
        );
      }

      // 時刻を分換算
      let bedinTotalMinutes = bedinHour * 60 + bedinMin;
      let wakeupTotalMinutes = wakeupHour * 60 + wakeupMin;

      // "就寝時刻" >= "起床時刻" の場合、"起床時刻"に24時間(1440分)を加算
      if (bedinTotalMinutes >= wakeupTotalMinutes) {
        wakeupTotalMinutes += 1440;
      }

      // "起床時刻" - "就寝時刻" を計算 (①)
      const diffMinutes = wakeupTotalMinutes - bedinTotalMinutes;

      // ① < "寝つくまでの時間" の場合は、"--時間--分"を返す
      if (diffMinutes < sleepTime) {
        // eslint-disable-next-line
        console.log("① < 寝つくまでの時間 の場合は、--時間--分を返す");
        this.answer = [
          0, // 分単位の睡眠時間
          0, // 寝つくまでの時間
        ];
        return (
          "--" +
          this.questionTexts.q3_zikan +
          "--" +
          this.questionTexts.q3_formFun
        );
      }

      // 睡眠時間を計算 (① - "寝つくまでの時間")
      const actualSleepMinutes = diffMinutes - sleepTime;

      // 睡眠時間が0分未満、または1440分を超える場合はエラー
      if (actualSleepMinutes < 0 || actualSleepMinutes > 1440) {
        alert("睡眠時間が不正です。入力値を確認してください。");
        // eslint-disable-next-line
        console.log("睡眠時間が0分未満、または1440分を超える場合はエラー");
        this.answer = [
          0, // 分単位の睡眠時間
          0, // 寝つくまでの時間
        ];
        return (
          "--" +
          this.questionTexts.q3_zikan +
          "--" +
          this.questionTexts.q3_formFun
        );
      }

      // 結果を整形
      this.answer = [
        actualSleepMinutes, // 分単位の睡眠時間
        sleepTime, // 寝つくまでの時間
      ];

      const sleepHours = Math.floor(actualSleepMinutes / 60);
      const sleepMinutes = actualSleepMinutes % 60;

      const result =
        sleepHours +
        " " +
        this.questionTexts.q3_zikan +
        " " +
        sleepMinutes +
        " " +
        this.questionTexts.q3_formFun;
      // eslint-disable-next-line
      console.log("sleep time result is...", result);

      const logInfo = {
        type: "submit",
        name: "track_sleep_time",
        userId: this.getLoginUserId,
        organizationName: this.getLoginUserInfo["company_name"],
        diagnosisId: this.getCurrentDiagnosisId,
        sleepTime: sleepTime,
        actualSleepMinutes: actualSleepMinutes,
        bedInHour: bedinHour,
        bedInMin: bedinMin,
        wakeupHour: wakeupHour,
        wakeupMin: wakeupMin,
        result: result,
      };
      // eslint-disable-next-line
      console.log("start dd event logging");
      // 送信イベントの計測
      datadogRum.addAction("track_sleep_time", logInfo);
      // eslint-disable-next-line
      console.log("start dd completed✅");

      return result;
    },
    isShowProfile: function() {
      this.hasProfile = true;
    },
    scrollTop: function() {
      setTimeout(function() {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }, 200);
    },
    updateLanguage: function(e) {
      // eslint-disable-next-line
      console.log("set language" + e);
      this.$store.commit("setValueToLanguage", e);
    },
  },
  computed: {
    ...mapGetters([
      "getLoginState",
      "getLoginUserId",
      "getLoginUserInfo",
      "getAccessToken",
      "getCurrentDiagnosisId",
      "getLanguages",
      "getLanguage",
    ]),
    returnProgressBosuu: function() {
      if (this.currentSectionNumber == 0) {
        return this.currentSectionQuestionsLength + 9;
      } else {
        return this.currentSectionQuestionsLength;
      }
    },

    returnProgressBunshi: function() {
      if (this.currentSectionNumber == 0) {
        if (this.currentSectionQuestionNumber == 0) {
          return this.currentQuestionItemsNumber + 1;
        } else if (this.currentSectionQuestionNumber == 14) {
          if (this.q11Branch) {
            return 23;
          } else {
            return 22;
          }
        } else {
          return this.currentSectionQuestionNumber + 8;
        }
      } else {
        return this.currentSectionQuestionNumber;
      }
    },
    calcCompletedQuestions: function() {
      // eslint-disable-next-line
      this.answeredQuestionsNum = 0;
      for (const questionId in this.answerConfirm[0]) {
        if (this.answerConfirm[0][questionId]["answers"] != "回答未完了") {
          // eslint-disable-next-line
          this.answeredQuestionsNum++;
        }
      }
      return this.answeredQuestionsNum;
    },
    returnGetLanguage() {
      return this.getLanguage;
    },
    isProfileEntered() {
      return this.getLoginUserInfo["is_profile_entered"];
    },
    isAnswerd: function() {
      if (typeof this.answer === "number") {
        return true;
      } else if (typeof this.answer == "object") {
        return Object.keys(this.answer).length == this.answerLength;
      } else if (this.answer == "") {
        return false;
      } else {
        return true;
      }
    },
    answerLength: function() {
      switch (this.currentQuestion["id"]) {
        case 3: {
          return 2;
        }
        case 4: {
          return this.sections[this.currentSectionNumber].questions[7].items
            .length;
        }
        case 9: {
          return 0;
        }
        case 12: {
          return 4;
        }
        case 14: {
          return this.sections[this.currentSectionNumber].questions[1].items
            .length;
        }
        case 15: {
          return 2;
        }
        case 16: {
          return this.sections[this.currentSectionNumber].questions[1].items
            .length;
        }
        default: {
          return 1;
        }
      }
    },
    currentSection: function() {
      return this.sections[this.currentSectionNumber];
    },
    currentQuestion: function() {
      if (Object.keys(this.sections).length) {
        return this.sections[this.currentSectionNumber].questions[
          this.currentSectionQuestionNumber
        ];
      } else {
        return false;
      }
    },
    currentSectionQuestionsLength: function() {
      if (Object.keys(this.sections).length) {
        return this.sections[this.currentSectionNumber].questions.length;
      } else {
        return false;
      }
    },
    currentQuestionItemsLength: function() {
      if (Object.keys(this.sections).length) {
        return this.sections[this.currentSectionNumber].questions[
          this.currentSectionQuestionNumber
        ].items.length;
      } else {
        return false;
      }
    },
    currentQuestionItemsId: function() {
      if (this.currentQuestionItemsLength > 0) {
        return this.sections[this.currentSectionNumber].questions[
          this.currentSectionQuestionNumber
        ].items[this.currentQuestionItemsNumber]["id"];
      } else {
        return -1;
      }
    },
    currentAnswer: function() {
      return this.answer;
    },
    q3CalcAnswer: function() {
      return this.calcQ3(this.q3Bedin, this.q3Wakeup, this.q3TimeToSleep);
    },
    q13CalcAnswer: function() {
      return this.q13Hour === "" || this.q13Days === ""
        ? ""
        : this.q13Hour * this.q13Days;
    },
    progressInCurrentSection: function() {
      return parseInt(
        (this.answeredInCurrentQuestion / this.currentSectionItemsLength) * 100
      );
    },
  },

  components: {
    Profile,
    TermsText,
    TermsTextEn,
    TermsTextCh,
  },
};
</script>

<style lang="scss">
$xs: "320px";
$sm: "480px";
$md: "800px";
$lg: "960px";
.input_range .v-slider__track-container {
  height: 6px;
  border-radius: 3px;
  overflow: hidden;
}
.v-application--wrap {
  background-color: #5592c6;
}
.input_range .v-slider__thumb {
  width: 20px;
  height: 20px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.3);
}
.input_range .v-slider__thumb:before {
  left: -8px;
  top: -8px;
}
.input_range .v-slider__thumb-label {
  color: #004d76;
  font-size: 14px;
  font-weight: bold;
  transform: translateY(-20%) translateY(-12px) translateX(-50%) rotate(-135deg);
}
.input_range .v-slider__thumb-label-container {
  left: 4px;
}
.input_range {
  font-size: 15px;
  color: #987654;
  margin: 36px auto;
}
.v-application ul,
.v-application ol {
  padding-left: 0 !important;
}
*:focus {
  outline: none;
}
.row {
  margin: 0 !important;
}
.btn_prev {
  display: inline-block;
  color: #fff;
  font-size: 14px;
  padding: 12px;
  min-width: 160px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 28px;
  margin: 8px;
  cursor: pointer;
  &:hover {
    opacity: 0.9;
  }
  @media screen and (max-width: $md) {
    padding: 8px 12px;
    min-width: 120px;
  }
}
.btn_next {
  display: inline-block;
  color: #fff;
  font-size: 18px;
  padding: 12px 20px 12px 12px;
  min-width: 240px;
  text-align: center;
  background-color: #ff7600;
  border-radius: 28px;
  margin: 8px;
  box-shadow: 0 2px 4px 0px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  @media screen and (max-width: $md) {
    margin: 24px 0 0;
  }
  &:hover {
    opacity: 0.9;
  }
  &.is-negative {
    opacity: 0.5;
    cursor: default;
    &:hover {
      opacity: 0.5;
    }
  }
  &-lg {
    padding: 16px 24px 16px 16px;
    font-size: 24px;
    letter-spacing: 0.05em;
    border-radius: 36px;
    font-weight: bold;
    min-width: 280px;
    &::after {
      top: 24px;
      right: 28px;
    }
  }
}
.radio {
  &_input {
    display: none;
  }
  &_label {
    display: inline-block;
    color: #4477a3;
    padding: 24px;
    min-width: 160px;
    text-align: center;
    background-color: #fff;
    border-radius: 48px;
    box-shadow: 0 4px 0 0 rgba(255, 255, 255, 0.5);
    margin: 8px;
    font-size: 18px;
    letter-spacing: 0.04em;
    font-weight: bold;
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(255, 153, 0, 0.5);
    transition: background-color 0.1s ease;
    &:hover {
      @media screen and (min-width: $md) {
        background: #f90;
        box-shadow: 0 4px 0 0 #c30;
        color: #fff;
      }
      @media screen and (max-width: $md) {
        animation: pressed 0.2s ease;
      }
    }
    @media screen and (max-width: $sm) {
      font-size: 14px;
      width: 100%;
      padding: 12px 16px;
      margin: 8px 0;
    }
  }
  &_label-narrow {
    padding: 12px 24px;
  }
  &_label:active {
    animation: pressed 0.2s ease;
    background: #f90;
    box-shadow: 0 4px 0 0 #c30;
    color: #fff;
  }
  &_label.is-pressed {
    animation: pressed 0.2s ease;
    background: #f90;
    box-shadow: 0 4px 0 0 #c30;
    color: #fff;
  }
}
@keyframes pressed {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(0.98);
  }
  50% {
    transform: scale(1.02);
  }
  100% {
    transform: scale(1);
  }
}
.checkbox {
  &_group {
    display: flex;
    flex-wrap: wrap;
    max-width: 1200px;
    margin: 0 auto;
  }
  &_label {
    display: flex;
    align-items: center;
    width: 46%;
    color: #4477a3;
    padding: 12px;
    min-width: 160px;
    text-align: left;
    font-weight: bold;
    background-color: #fff;
    border-radius: 4px;
    border: solid 1px #f3f3f3;
    box-shadow: 0 2px 0 0 #ccc;
    margin: 8px;
    cursor: pointer;
    &:hover {
      opacity: 0.9;
    }
    @media screen and (max-width: $md) {
      width: 100%;
      font-size: 14px;
    }
  }
  &_input {
    width: 12px;
  }
  &_labelTxt {
    display: block;
    padding-left: 8px;
    flex: 1;
  }
}
.v-text-field.textarea_inline {
  width: 5em;
  display: inline-block;
  margin: 0 0.5em;
  vertical-align: middle;
  &-wide {
    max-width: 320px;
  }
}
.v-slider {
  max-width: 10cm;
}
.input_range {
  max-width: 10cm;
}
.is-transition {
  .question {
    &_questionTxt {
      opacity: 0;
      animation: fade 0.2s ease forwards;
    }
  }
}
.is-transition .question_progressBarIn .question_progressBarBg {
  background-color: #f90;
  animation: progress 0.5s ease forwards;
}
.is-transition
  .question_progressBarIn.is-active
  .question_progressBarBg::after {
  border-left-color: #f90;
  animation: progress-2 0.5s ease forwards;
}
.question_progress {
  /* display: flex; */
  position: fixed;
  width: 100%;
  padding: 20px;
  background-color: #5592c6;
  z-index: 1001;
  box-shadow: 0 3px 16px rgb(0 0 0 / 30%);
  @media screen and (max-width: $md) {
    position: relative;
  }
}
@keyframes fade {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes progress {
  0% {
    background-color: #f90;
  }
  100% {
    //background-color: #c30;
    background-color: #004d76;
  }
}
@keyframes progress-2 {
  0% {
    border-left-color: #f90;
  }
  100% {
    //background-color: #c30;
    border-left-color: #004d76;
  }
}
#question {
  background-color: #5592c6;
}
.question {
  min-height: 720px;
  &_welcome {
    text-align: center;
    padding: 48px;
    color: #fff;
    background-color: rgba(0, 0, 128, 0.2);
    border-radius: 4px;
    @media screen and (max-width: $md) {
      padding: 24px;
    }
  }
  &_welcomeTtl {
    margin-bottom: 24px;
    color: #fff;
    @media screen and (max-width: $md) {
      margin-bottom: 0;
    }
  }
  &_welcomeTxt {
    margin-top: 24px;
    color: #fff;
  }
  &_policyBox {
    max-width: 640px;
    margin: 24px auto;
    background-color: rgba(0, 0, 0, 0.07);
    padding: 24px;
    border-radius: 4px;
    max-height: 160px;
    overflow-y: scroll;
    text-align: left;
  }
  &_policyTxt {
    font-size: 13px;
    color: #fff;
    line-height: 1.75;
  }
  &_policyCheckbox {
    margin: 16px auto;
    text-emphasis: center;
    .checkbox_labelTxt {
      margin: 0 auto;
      padding-right: 24px;
      text-align: center;
    }
  }
  &_sectionTtl {
    color: #4477a3;
    margin-bottom: 20px;
    @media screen and (max-width: $md) {
      font-size: 24px;
      margin-bottom: 0;
    }
  }
  &_progress {
    @media screen and (max-width: $sm) {
      padding: 12px;
    }
  }
  &_progressBar {
    width: 100%;
    height: 48px;
    background-color: #78b5ea;
    border-radius: 24px;
    display: flex;
    justify-content: space-between;
    color: #fff;
    font-weight: bold;
    overflow: hidden;
    @media screen and (max-width: $sm) {
      height: 28px;
    }
  }
  &_progressTxt,
  &_progressNum {
    position: relative;
    z-index: 2;
    @media screen and (max-width: $sm) {
      font-size: 11px;
    }
  }
  &_progressNum {
    display: none;
    margin-left: 0.5em;
  }
  &_progressBarIn {
    position: relative;
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    &::after {
      position: absolute;
      right: -20px;
      content: "";
      width: 48px;
      height: 48px;
      border: solid 3px #5592c6;
      border-left-color: transparent;
      border-bottom-color: transparent;
      transform: rotate(45deg);
      z-index: 2;
      @media screen and (max-width: $sm) {
        width: 28px;
        height: 28px;
        right: 0px;
      }
    }
    @media screen and (max-width: $sm) {
      justify-content: space-evenly;
      width: 25%;
    }
  }
  &_progressBar &_progressBarIn:last-child::after {
    display: none;
  }
  &_progressBarBg {
    display: none;
  }
  &_progressBarIn.is-active &_progressBarBg {
    background-color: #004d76;
    display: block;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    transition: width 0.5s ease;
    &::after {
      content: "";
      width: 48px;
      height: 48px;
      border: solid 24px transparent;
      border-left-color: #004d76;
      position: absolute;
      right: -48px;
      top: 0;
      @media screen and (max-width: $sm) {
        width: 28px;
        height: 28px;
        right: -48px;
        top: -10px;
      }
    }
  }
  &_progressBarIn.is-active &_progressNum {
    display: inline-block;
  }
  &_progressBarIn.is-completed &_progressBarBg {
    background-color: #004d76;
    display: block;
    width: 100% !important;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  &_nav {
    height: calc(10vh);
    background-color: #004d76;
  }
  &_nav_btn {
    display: block;
    width: 100%;
  }
  &_questionArea {
    color: #fff;
    width: 100%;
    min-height: 360px;
    height: 40vh;
    padding: 32px 10vw;
    align-items: center;
    display: flex;
    @media screen and (max-width: $md) {
      padding: 0 12px;
      min-height: 30vh;
      align-items: normal;
      height: auto;
    }
  }
  &_questionAreaIn {
    @media screen and (max-width: $md) {
      display: block !important;
      h2 {
        line-height: 1.5;
        font-size: 18px;
      }
    }
  }
  &_sectionTxt {
    font-size: 16px;
    display: inline-block;
    position: relative;
    letter-spacing: 0.04em;
    &::after {
      content: "";
      display: block;
      width: 100%;
      height: 2px;
      position: absolute;
      bottom: -2px;
      background-color: #fff;
      // @media screen and (max-width: $sm) {
      //   display: none;
      // }
    }
    @media screen and (max-width: $sm) {
      font-size: 14px;
    }
  }
  &_questionTxt {
    font-size: 28px;
    margin-top: 12px;
    letter-spacing: 0.04em;
    @media screen and (max-width: $sm) {
      font-size: 18px;
      margin-top: 24px;
    }
  }
  &_answerArea {
    color: #fff;
    width: 100%;
    min-height: 60vh;
    padding: 48px 32px;
    background: #004d76 url(../assets/bg_answer.svg) right 24px bottom 24px
      no-repeat;
    text-align: center;
    .col {
      position: relative;
    }
    @media screen and (max-width: $sm) {
      padding: 24px 12px 80px;
      background-size: 200px;
      min-height: 64vh;
    }
  }
  &_cover {
    background-color: #5592c6;
    color: #fff;
    width: 100%;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    @media screen and (max-width: $sm) {
      padding: 16px;
    }
  }
  &_list {
    list-style: none;
    display: flex;
    justify-content: center;
    padding: 0;
    @media screen and (max-width: $sm) {
      display: block;
    }
  }
  &_debuggerCont {
    display: none;
    &.is-show {
      display: block;
    }
  }
  &_debuggerBtn {
    position: fixed;
    right: 16px;
    bottom: 16px;
    display: none;
  }
  &_prev {
    position: fixed;
    left: 12px;
    bottom: 12px;
    @media screen and (max-width: $md) {
      position: absolute;
      bottom: 5vh;
    }
  }
  &_illustArea {
    width: 35vw;
    position: absolute;
    top: 16vh;
    right: 10vw;
    pointer-events: none;
    @media screen and (max-width: $md) {
      position: relative;
      width: 100%;
      top: 0;
      right: 0;
      order: 1;
      text-align: center;
    }
  }
  &_illust {
    min-width: 400px;
    max-width: 600px;
    min-height: 240px;
    max-height: 300px;
    height: 30vh;
    @media screen and (max-width: $md) {
      min-width: 0;
      max-height: 160px;
      max-width: 200px;
    }
    @media screen and (max-width: $sm) {
      height: auto;
      min-height: 0;
    }
  }
  &_txtArea {
    max-width: 40vw;
    @media screen and (max-width: $md) {
      max-width: 100%;
      order: 2;
    }
  }
  &_nextBtn {
    margin-top: 24px;
    @media screen and (max-width: $md) {
      margin-top: 8px;
    }
  }
}
.q3 {
  &_formBlk {
    display: flex;
    max-width: 980px;
    margin: 0 auto;
    justify-content: space-between;
    @media screen and (max-width: $lg) {
      display: block;
    }
  }

  &_box {
    padding: 24px;
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    margin: 0 8px;
    @media screen and (max-width: $lg) {
      margin: 0;
      & + & {
        margin-top: 16px;
      }
    }
    h3 {
      margin-bottom: 12px;
    }
  }
  &_answer-1 {
    @media screen and (max-width: $md) {
      margin: 0 auto;
    }
  }
  &_answer-2 {
    display: inline-block;
    vertical-align: middle;
    line-height: 1;
    margin: 0;
  }
  &_answer-3 {
    margin: 0 0.5em !important;
    display: inline-block;
    font-size: 36px;
    vertical-align: middle;
    line-height: 1;
  }
  &_answer-4 {
    @media screen and (max-width: $md) {
      margin-top: 24px;
    }
  }
  &_answerBlk {
    display: flex;
    margin: 24px auto;
    text-align: center;
    justify-content: center;
    align-items: center;
    div {
      margin-right: 24px;
      @media screen and (max-width: $md) {
        margin: 0;
      }
    }
    @media screen and (max-width: $md) {
      display: block;
    }
  }
}
.q12 {
  &_answer {
    font-size: 14px;
    text-align: center;
    & + & {
      margin-top: 48px;
      border-top: solid 1px rgba(255, 255, 255, 0.25);
      padding-top: 48px;
    }
  }
  &_itemTtl {
    font-size: 20px;
    font-weight: bold;
    display: block;
    margin-bottom: 8px;
  }
}
.q13 {
  &_answer-1 {
    font-size: 36px;
    display: inline-block;
    margin: 0 0.25em;
    font-weight: normal;
  }
  @media screen and (max-width: $md) {
    > span {
      display: block;
    }
  }
}
.q15 {
  display: flex;
  width: 800px;
  margin: 0 auto;
  justify-content: space-between;
  .textarea_inline-wide {
    margin: 0 auto;
    width: 240px;
  }
  @media screen and (max-width: $md) {
    width: auto;
    justify-content: space-evenly;
    .textarea_inline-wide {
      margin-top: 8px;
    }
    flex-direction: column;
  }
}
.q16 {
  &_item {
    padding: 48px 0;
    border-bottom: solid 1px rgba(255, 255, 255, 0.5);
    text-align: center;
  }
  &_item:first-child {
    padding-top: 0;
  }
  &_question {
    font-weight: bold;
    font-size: 20px;
  }
}
.q19 {
  &_answer-1 {
    font-size: 36px;
    display: inline-block;
    margin: 0 0.25em;
    font-weight: normal;
  }
  @media screen and (max-width: $md) {
    > span {
      display: block;
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-leave-to {
  opacity: 0;
}
.fade-enter {
  opacity: 0;
}
.fade-enter-to {
  opacity: 1;
}

.confirmText {
  margin-bottom: 24px;
}

.headline {
  background-color: #5592c6;
  font-weight: bold;
  color: white;
}

.cartText {
  color: red;
}

.headlineBrowseBack {
  background-color: #920925;
  color: white;
}
</style>
